var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUniquelyAddressing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 460,
    height: 269,
    viewBox: "0 0 460 269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1262",
    "data-name": "Rectangle 1262",
    width: 460,
    height: 269,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#13c8ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13d7bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -15.413,
    y1: 0.104,
    x2: -14.615,
    y2: 0.896,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5778ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    stopColor: "#5488ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#4db2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#48d4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#44ebff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#42faff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42ffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -9.623,
    y1: 18.179,
    x2: -9.071,
    y2: 17.543,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14e2c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11ad97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#151e31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#626875"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01f2b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a1ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 84.71,
    y1: 0.5,
    x2: 85.71,
    y2: 0.5,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 83.165,
    y1: 0.5,
    x2: 84.165,
    y2: 0.5,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 81.615,
    y1: 0.5,
    x2: 82.615,
    y2: 0.5,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 86.463,
    y1: 0.5,
    x2: 87.463,
    y2: 0.5,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 84.918,
    y1: 0.5,
    x2: 85.918,
    y2: 0.5,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 83.368,
    y1: 0.5,
    x2: 84.368,
    y2: 0.5,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#131c2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757d80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f283a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737580"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    d: "M347.374,164.153l79.58,45.946-9.869,58.182-79.527-45.917Z",
    transform: "translate(-337.558 -164.153)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a2336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373f4f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_10",
    "data-name": "Mask Group 10",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40027",
    "data-name": "Group 40027",
    transform: "translate(22 218.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766",
    transform: "translate(0 -218.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_751",
    "data-name": "Group 751",
    transform: "translate(134.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654",
    transform: "translate(0 180.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M471.776,301.843a7.084,7.084,0,0,1-3.549-.948L444.08,286.953l.6-1.039,24.147,13.942a5.912,5.912,0,0,0,5.9,0l23.869-13.781.6,1.039-23.869,13.781A7.086,7.086,0,0,1,471.776,301.843Z",
    transform: "translate(-413.223 -268.951)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M423.513,285.64c5.049,2.913,13.236,2.913,18.286,0s5.049-7.642,0-10.557-13.236-2.913-18.286,0S418.463,282.724,423.513,285.64Zm4.2-8.133a10.925,10.925,0,0,1,9.889,0c2.729,1.576,2.729,4.131,0,5.708a10.928,10.928,0,0,1-9.889,0c-2.73-1.577-2.73-4.131,0-5.708Z",
    transform: "translate(-414.443 -269.605)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_653",
    "data-name": "Group 653",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M432.907,291.274a26.08,26.08,0,0,1-12.754-3.046h0c-3.52-2.031-5.458-4.77-5.458-7.71s1.937-5.678,5.459-7.709c7.032-4.063,18.474-4.063,25.507,0,3.52,2.031,5.458,4.769,5.458,7.709s-1.938,5.68-5.459,7.71A26.083,26.083,0,0,1,432.907,291.274Zm-12.153-4.086c6.7,3.869,17.606,3.869,24.306,0,3.132-1.809,4.859-4.179,4.859-6.669s-1.726-4.861-4.858-6.669c-6.7-3.871-17.606-3.869-24.306,0-3.132,1.808-4.859,4.178-4.859,6.669S417.622,285.38,420.754,287.188Z",
    transform: "translate(-414.695 -269.761)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661",
    transform: "translate(38.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    width: 7.309,
    height: 121.48,
    transform: "translate(66.788 9.073)",
    opacity: 0.66,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_290",
    "data-name": "Rectangle 290",
    width: 7.309,
    height: 64.017,
    transform: "translate(53.431 45.618)",
    opacity: 0.66,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAD+CAYAAADGQw4jAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABNBSURBVHhetV3JrmVJUryZLRASgg18GnTVZyCxQCpaTdPQvegVn1FZ8F0skRjFlJW4mbn5EOfc915mJ+E6ER7m5m4xnHvz5VCqd58+fXp8zfbtd493tIf67//28VGRbl9V9Nu/fLyPgWKf3oUvaYzvPvzi8Z8kRfsqorW7sBKTOGZYCMU//Pzx73R/G9F5lJ9QfIq1vY+FEP3hZ49/I+FLRM97y91ti5YLMY/eD989/kVb/4yWgiyGolUYo33sTr4eo/CjvXmnb703HyXRyQnzibwqejlKCQhra7FrjBYqKfmK6M1HYFu0u3uLp7gUO+ypaAj+JAj9eVMpC3CWu7OAUFjwhlijmoXzpK2XRHLlZ8y4UHMQM26OvRiRe7vTb37++J0YRGv7rHs7OCv3IkrBTgWJpbizLpSoeMdRvpb77nq87+Ius1iYjxLzRuX/BMd4HOVLuZW9dvrNLx6/l4F9lKCPlcIoNjltZ64/w2V7pwHk6hD0CuWnrd01h7ObXM9omds7/eaXj99nQq8JTQkx+9x7I75zHX1fO60Vdrm5OuHNMcv3duKceWeJoiejj9chBWiRgBfjTOK4xMwY2bVQx2Wc83h/+uvHH2aQVkcJ5DgyiKXf+LBxlFUvDK2uwG8W15HHobJKIU4PsY5MnLPMVdRx+4iZHSNFA+BnTuEMBUZPCUoC5lLJytzOMyt95GXtwrRTTxOkxVhixuFpRquFOi7jvMQcVRzju3d/8ptPf1wwDC2T6E08086PQI5ixJhimzUMZd701RUsf+1ZBlEdpBDtrrOIVR/mfIWVoN2ZInwmwHdvDh+KOdpxzRDXY8b7LYbHdHlKENbxZCwx9d65kDDGm0FMTk4yRDtXl1bJuZCOi1Pcke+YomFrAv8ipoTya3fXOL1LfkcdzztVSKs3UmgcWfjHUTqOGZGIXz+vZsSIGPODxwAmTJjkpB9i6jXaZ35i6Ik5iroZL4bENNVHp0IU7FlitBxRLPNnTJbxgdkbL5K+9OjX7pLERz69IZZIRR33b6gSKY9XpYRMfuNRTsbITrHGHMloLYYvkl8CJxeJXif4uPU4rth5bysX48iNO+2w+5kqsRl3NGdLTL5HeFpQR9nPaaeKvMXsaaZija1cPEOsOep5p9evLvY5T8xWYm2X3CU2KySmgBNiRFHOTdUcQvvexNEobObuPsesoa9BFGMCU/PzirkwrHxi8tCnx2KNiWOmXlKKcRZji6mXp5mKNeaC8uNhXFhz1DMOf4rRwncQsAIxllhjSmjsem8jhlnWaHOt8EykRSEITsx+jSzm+O45lpgyZJiLxxetEopowvb2UXo84zPaxjg8L9ZkTPm9KJhGbIkZ7ZF+5gvvmOohHnMuKOdN3imYvf3eFFN0eEOsMIwYapLePEqgs+c4xBZOL7lLrHuOBvTTQfi1u1xAzRzvuax5xLi7nWtWYZwsse5FzdkTMXnRU0xzmaKz9wnFj6CCTkq/BPnEzFGNyTvEZmz1qUNTiU0h9ooY/TwdY450RvRZxwgZog0A/hLbMcVjTk7OV2+OHkcw+qmPDCckai5rX/GYp5hiinaf8RITXleVc30jJZGAAxxF5ttYYsJ6HP0hBv+cU0fFWsRWCWPnGt2PGWqUYIvN+eIoAENwHMWL93ZTKDE/sqxRnMRANcDxcpSKrv6uEPs935xC++29v7cbyXHcjvvxfJ9AoenH781Falij+zFbhd4iBkyeZumBM3fX9O53IRn8nkfpJ5w58k8eYnPEMHhNCalHkVVILLxoPY/xIoZZxsIkhqex/BqEaWQPUpnLNKM4Q3CUpDfFjNWIzs8shCIr5vEVMdozMftMOgrBg7/mKLI4ZjW27o297OTxRWrCjRhGLGqYi9jOo7TtmYwvnQItBk8WOAsZN0tW/hBrHiO0wrIWZv3lEE/ZEJNdPfxR3N1R2gqbYomNBIH7uJtaCehZ5OTtkf4plmN/93JFndJUFdr31tG7jHWU0ZeYRxO6yCyTXolNnsbpn2K2i9/AdfX8y4Sbezt5XPQhVn9Mm0Y/apGHicOdAIL8S+IY6V/EEj9GnybjM7jv7SZx+OdRnmJlECNPHMaLdBG7OR5gh5jt9MGbYsY50nnLvcE/xFzMVtxnYjlGofsVLwxFBm8W80Mbu4OtGvFUngMngSPFhKykHMsbYrdv7ezBuxLCDjEYBC/cJTbwMRp3TeLoTIDpuLcY8WN0gdfEsCg+OSde5FyJ7UWxwSs8/ZV3qZff9S12dxfDH2Io8BqX/EL7F5bc6TzKG2Ec9xATLtYqhNkhNhfnXBjf3i62Rxc447aFH2LoZ66NGDqTPbIAVp1W+J0P3lqcj3IyzY0eXIcExphidyuEATfXYo5Mjq0w1s1lVdIhZvws5BfvTmD6Nv1YA35H9Qcd2LaB4cFfi7h8FY5FDxNXj8XArFw4gGfyxa8CVzEvClbYEutY5WJi8ixEf4g5MjmIYF7YZXFPcldSjl/l3nK8zUXQExJRIE14r3BacYfYVeDMTQbAXcC08yhlhd2IPc9NRmqMP+8lHOHXxcxvsYw9yS0xWkQ2SUkrIYxYiXX05Vx5/rJpVmBK9ApdRsaZv7pGks3Izk1GLrJZRMk6qbTCniTJztxklJhs56HF2EUOsXhuY4dftsQ6Ii7amLsAxvPergL393aKzfjJJeKipxisBfooZcnIRTaL6D13ev7IwK5J93feYtvERdNo3Aj/1WTkBbGDdwIzdYspgn6LtS0EYvSix7fIFnt2lCdLMyzafqON8F/0cKEDQylNz6NMUu1uofcLm56P0nMaWvRY6RZLKzFYR8RF27iRLea4ooX1ThOIhOtXl68AzTHZQm4W2bOBuRgnFzHN3npvk+WZ+o1JFGIl2OW0IFsnl3cc5TyNO0wW3nmUsE2c9PRv703eHdZeRs9vIXibuBEK0gZWjGfY9KL3ET47yrK1OxtL3GKwuSG1mOFkv+woFb3D7Lt3I85TinbutAiwm3vr2cZkwBxVI47d5bWQ0UeQBFjuzgVkZjzDppecEhPifn85rKO0od1j9t27XcXaQ0/R+iUHQPZNu2L221PjLE8IMz32bNHwORU0A/eYDJijasRrd2aYJ6/Z0XynMjSN99j00GJ2OUr19mSzxWx+ZJrUmH33bhDTfz/BWT7dO6+bOOz7RTIVTZ4wR9WIv+XeqjliZrR9vLYrlfjn3BvbZI42j9eETY3Zl9zbBRtNoiK4dyP+pffG+X2LH7cmVY3Fnh6lbTZHzHzePoVxp6ay2KtHebbJfN6ipATRsFMWu4hJwHPZbCfnvrVYCqLxTg8xe+i/qpib/wMpl5jetejrYmhPxdgiqjs9xU5BRTd2bZJ6QcxRv72vib0k2GIvCXar36H8/4m1YDH19s72uhjaF4nZa9He3UtNaSpxbVsMTb6y2EIgX6SvdZTdLnyI4YH1i/S8vS4mhmZmJjLE3N/cabdBu2mSmlH5ymI7xCp+J3rSdpPUjFz43F3zhA7WFB0w59emqFszE11HOWN7XqKvi7mUWC7AZ4ntHs1e1YBoujdNtBmVrxJsFzG07u11lfDe1+RsTUNTAfVsY3eNbs/R0193qtZBzfS4vztKxaZnc5NfaIsWlDM95d2IuUebnkY0+G1uPN4NdbK9z7m302+s0Zc/MmN3jW7P0dNvr33j+fbqcf9V7i2bZ+zz56LcqeCvem/DSsx4fWQuYmjd25Ntv7FGiZ9iaY/3Y3cKom3PUflo5k60Z+whOFDP0H7UTic4vZmAptmPOboJ09hHaZ4YM7depNnb04imBMWuKLHLUYrhjLmAvFMBBeZ8+u21T/zZvWXfp6KRJzJ36rCa/I32jP1L9zaQZFefX4Mdlt/m5hn7NxylmqJ1357ra7AJHVIzSvuSo+RckR+Rixrzu7e99o1fxcy6HuXcGT2LGdWdytR6xr521zhmeK73JsxxzivXY1h9I0UTpPG3vre1uzbO504JXcQqwr53p/E8yi2mvr3M94vEPsiTCH+REwF2vTcIpp89WBr3YvU1WLuzoYkwkVlqxm/vLQxtisGYyy/8gtA8c4Iw2GfdW/ReHMy54Ofxyia551sMz5vurfrBgiDM30hoLYYmz708CE502rnY0UPMgkC8UySo9RxW89xdIzLMLtwct9gwv72dIK/mX3Bv/BQssSPbn9Pz3i5fXWmez93d3hut82xEfLyYmIJ7a3TaeW8QTH/szotoqwOXx8+pgdrdTpqz4tobYs8MTMmixQjR8972bnp3sL63QJeYs9u6Hlp4wecpvi+xTvJ8in/2vYXVYi2WFl+DOwlt71TJJVbJVzGb8tFinGI51i/iFwH66S0xmQvYsNRTDLsDVmI51o8rs8iXHSVaeCk2rTk5zp1exCrZaW27UMwOsb2J7dfxcgJviT03iymny9rr45bRzze+XqRXv7rCGkGLEQUyp8X2vPBZmztFckGd9qzQFIMBf1Es6/vh5zTDObbtQtFuxJ75U2waa/pO76zEMI4CHoHPooUfYhf/FO39DjGsOuhVNEcjhYMXL4vnzT9eqvmRIZDjW+7Ndh6lx5PPenjmRwa0z7k3FgC/UPlPxYgFKlE0BYqYowvYCr8Ru/WnWJqOFwUyaLusNsfXjtLWuxti9vojA/CGkOgWa2YvTth5lMQ4MxYPdjoLnAQWKDEZ/PMkzIP1ktqaFx5EXzrKmf7UT94Uu92lP05zpx6/yr0Ng5hPgXO9vSKfYrbLSZQYMKEzp3nhDbEyvb0K7sSelYfjOcTk73HybODLYjbfXpgTLy/VW8TgYwPD9kxWb6+DLx/lHqc/jxJYc7RMPqwVnu/09XubezQvsCG2bfDJcUb080Wyvf0o24cpdiyuahkJ36KcgBArel0sZrlyzodX/Ky1MHu8UxIc2OP0z6Nszp3YyFvM6P32OtDhkXSIwcxe/ENs+hxzQXG8TbkVzkI1z35zokexiXGW2IijX1/4077KUS6xjq2vQT5LbJUo/yqG2GRGfyNWXr29S0wm6iwXsyWW2BzX7ppln73e3g7C9kw2d2dby1liXWMJBwdaP/bb20RRs8AQM2cXitkScz846JPDeR0vbVAPMdnhrQVfWeb0ojKCj4xMRNhceWHJIZYLgv9RCM1VzHGdwjiGzZ1+/r0pNjnzuDuGPj3U0IsUToptsv3ob8SabU4jZ/7a0PtDbNI5JvnjisjHzBztzujgALeY0XW8meBCvbtdyH6Lad5j5qFGWWJ4eLx0M7TEFPNYnHg+LjF5xc0aC0ufnndKyiE2Iu3l7jSfsbAh1mj3RCL+kaJrd51kn32KDSS9zHtVTBzO8CKZoLDJ6S+x5tW4ducYHn2Cd37G5516lB/9ITa952LpHYvtSPTrTj2OhDNtixntngjy6c24PMb0k4MC571pTDLGJys32kfZqDk8NSwYMx7vEktSjkwCOeIzqid5R75YjkePeM3i8YskYnv8BnpRLJ6Izc+rIvUK5WKE9zdaPPNFqrQlZnQkoefqz7i8KWZMUfX1NUgyRpJtTZen+HnvHY9+idlLH3l49OspgAhxd5gnljP2S0xl5pHN+MzDwysYMf2wTbE2BYtyEZtxiV1xIYidSPQ+XgAwvwRE1u46mbyLmL30kRcPTkNIc+K79ybpBTH2EbvF0adYI4OTsfH2Aow+E2SOZF+7w6xxzpeYGclhbCD+vQwSdBRFZU8rMc3XFeB59zFfKiPokZe5hSQPL1LvTqOe6JfYwO2z6EQGZ4nZMtafUz/ZRxJ2dMHRD7H9RM+Y/LaMO9Y/92YawHjoj57IIaYe8xhLDDiOsXkVZyxGv0gviuG5iA28xMBpHr2K28LnF/4Sw9OvSu9OVmLoiU8xGbNLDPF+0ci4fk5FazEjg1MFp2V8ic0Y8Mxdn9Pst5j7GJ8WHPG7mMVy/nf1Oc0gnstXFz6HFzHxMF53Li798Rnm/O///PEtd5piDpQY+sQzJW3E1mLkkxOx3p1MXrT+EXQmRl8Fp4n3fOfRLzFFq2cORGOicIZKbBbUvOJ3sRux+hSgHmI//MXjnyxq0otfXZfFyCcHgnNuz2Jl2fgisWAeT1kXPHfuF4hiWfR/hWQk+rPeD989/jk18T8jCejmuNDfxsJKbHDdX3YnDv5wt5q/e+dr7aPslXZMBcecFv4h5npk/fCzx7+mHtv6wk8xkfMlUBoL9u5k9JhjpG3G1i7R+nMK2mtHKZMXPXOmYR41SizmH/7q8R+pVa1/wp+JcTxLDM/45aqOcmDxoL98A6XOan28g7jEZCx53Js5ZAGPZy7/xw9//fiv1Fltfk6ZVIIyedEvMVjntFjn/fjhl4//To1L405fFMPjY3QkJAK7iiXvw988/ifr37b3//Bnj39cibDwXzvKnDtKYw6wV5r+NZ2SQNdP7lkkDS8GywPn7oA5mhY4se9/Ff0rrf7nU3/6m8cf5Q7a9JdfWL3+sqj/yqh4+AdUsLeIuWmn0dbuUBalwufONO94WB1l2OcIoq3/odhPf/X4gyjO/eXuakc2CqX//a+j/4K2RNHw//hiSUkuUR4ldvaFYm4XUbdvfv743SUW9rnHeN8ej/8DRaNxTIjIckwAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 7.309,
    height: 79.894,
    transform: "translate(40.073 66.285)",
    opacity: 0.66,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 7.309,
    height: 153.74,
    transform: "translate(26.716)",
    opacity: 0.66,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 7.309,
    height: 131.057,
    transform: "translate(13.357 30.496)",
    opacity: 0.66,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 7.309,
    height: 55.447,
    transform: "translate(0 47.887)",
    opacity: 0.66,
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657",
    transform: "translate(10.909 92.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M590.958,343.782a6.635,6.635,0,0,1-3.264-.767h0l-124.78-72.434a2.606,2.606,0,0,1-1.476-2.223,3.379,3.379,0,0,1,1.967-2.743l84.423-48.742a8.112,8.112,0,0,1,7.406-.283l124.778,72.437a2.606,2.606,0,0,1,1.476,2.223,3.378,3.378,0,0,1-1.967,2.743L595.1,342.735a8.472,8.472,0,0,1-4.139,1.047Zm-2.662-1.8a7.009,7.009,0,0,0,6.2-.283l84.423-48.741c.855-.494,1.365-1.131,1.365-1.7a1.5,1.5,0,0,0-.877-1.187l-124.78-72.435a7.013,7.013,0,0,0-6.2.282l-84.423,48.742c-.855.494-1.366,1.131-1.366,1.7a1.5,1.5,0,0,0,.877,1.186l124.778,72.436Z",
    transform: "translate(-461.438 -183.987)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M587.964,329.364,463.188,256.928c-1.744-1.007-1.526-2.766.488-3.929L548.1,204.257a7.565,7.565,0,0,1,6.8-.283L679.68,276.411c1.744,1.007,1.526,2.766-.488,3.929l-84.42,48.741A7.579,7.579,0,0,1,587.964,329.364Z",
    transform: "translate(-461.409 -184.615)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    transform: "translate(8.575 17.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M672.5,271.568l-26.523-1.728-90.793-52.816a6.966,6.966,0,0,0-6.269.259L490.529,251l-20.922-1.363v3.444h.019a1.84,1.84,0,0,0,1.066,1.576l116.231,67.5a6.967,6.967,0,0,0,6.269-.261l77.776-44.9a2.607,2.607,0,0,0,1.519-1.982h.014Z",
    transform: "translate(-469.604 -201.847)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M586.92,319.452l-116.231-67.5c-1.61-.928-1.405-2.549.451-3.62l77.776-44.9a6.965,6.965,0,0,1,6.269-.261l116.23,67.5c1.61.928,1.406,2.549-.449,3.62l-77.776,44.9A6.969,6.969,0,0,1,586.92,319.452Z",
    transform: "translate(-469.603 -202.543)",
    fill: "#333b4c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M675.436,256.47l-27.317-1.78-93.033-54.109a7.178,7.178,0,0,0-6.458.268l-60.143,34.725-21.55-1.405v15.037h.02a1.9,1.9,0,0,0,1.1,1.624l119.235,69.235a7.178,7.178,0,0,0,6.458-.268l80.112-46.252a2.683,2.683,0,0,0,1.564-2.043h.015Z",
    transform: "translate(-461.162 -184.783)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M587.288,305.635,468.054,236.4c-1.655-.956-1.447-2.625.464-3.729l80.112-46.251a7.166,7.166,0,0,1,6.458-.268l119.234,69.237c1.655.956,1.447,2.624-.464,3.728l-80.113,46.25A7.173,7.173,0,0,1,587.288,305.635Z",
    transform: "translate(-461.162 -185.507)",
    fill: "#12151c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    transform: "translate(207.187 132.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M650.376,230.646a10.839,10.839,0,0,0,9.807,0c2.708-1.564,2.708-4.1,0-5.663a10.839,10.839,0,0,0-9.808,0C647.668,226.548,647.668,229.083,650.376,230.646Z",
    transform: "translate(-648.345 -223.811)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659",
    transform: "translate(14.867 12.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M663.574,239.518a5.71,5.71,0,0,0,5.169,0c1.427-.824,1.427-2.16,0-2.983a5.71,5.71,0,0,0-5.169,0C662.146,237.36,662.146,238.693,663.574,239.518Z",
    transform: "translate(-662.503 -235.916)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(106.02 242.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M516.97,332.826a7.029,7.029,0,0,0,6.359,0c1.756-1.013,1.756-2.657,0-3.67a7.023,7.023,0,0,0-6.359,0C515.214,330.169,515.214,331.812,516.97,332.826Z",
    transform: "translate(-515.653 -328.394)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663",
    transform: "translate(100.8 239.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M520.4,336.911a13.875,13.875,0,0,1-6.786-1.62c-1.889-1.09-2.929-2.564-2.929-4.149s1.039-3.059,2.929-4.149a15.009,15.009,0,0,1,13.573,0c1.89,1.09,2.929,2.563,2.929,4.149s-1.039,3.059-2.929,4.149A13.875,13.875,0,0,1,520.4,336.911Zm0-10.751a13.062,13.062,0,0,0-6.386,1.526c-1.63.941-2.53,2.169-2.53,3.456s.9,2.514,2.53,3.456a14.142,14.142,0,0,0,12.773,0c1.631-.942,2.53-2.169,2.53-3.456s-.9-2.515-2.53-3.456a13.063,13.063,0,0,0-6.386-1.527Z",
    transform: "translate(-510.683 -325.37)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749",
    transform: "translate(76.696 52.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706",
    transform: "translate(42.091 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M551.674,171.78l20.818-12.019-20.817-12.019-20.818,12.019Z",
    transform: "translate(-527.658 -147.742)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M551,225.63l-22.773-13.147a.823.823,0,0,1,0-1.426L551,197.908a1.664,1.664,0,0,1,1.661,0l22.773,13.149a.823.823,0,0,1,0,1.426L552.658,225.63a1.663,1.663,0,0,1-1.663,0Zm.3-27.2-22.775,13.149a.222.222,0,0,0,0,.383L551.3,225.11a1.066,1.066,0,0,0,1.059,0l22.773-13.149a.221.221,0,0,0,0-.383l-22.773-13.149a1.066,1.066,0,0,0-1.059,0Z",
    transform: "translate(-527.811 -145.237)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    transform: "translate(6.376 56.349)",
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M551.522,221.768l17.639-10.185L551.523,201.4l-17.64,10.185Z",
    transform: "translate(-533.883 -201.4)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M551.674,215.709l20.818-12.019-20.817-12.019L530.857,203.69Z",
    transform: "translate(-527.658 -145.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M530.857,159.184V205.32l20.817,12.019V171.2Z",
    transform: "translate(-527.658 -147.167)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M571.5,159.184V205.32L550.68,217.339V171.2Z",
    transform: "translate(-526.664 -147.167)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M533.831,169.8v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-527.509 -146.635)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M533.831,174.708v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-527.509 -146.389)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M533.831,179.618v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-527.509 -146.143)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M533.831,184.528v1.22l14.572,8.413v-1.222Z",
    transform: "translate(-527.509 -145.896)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M533.831,189.438v1.22l14.572,8.41v-1.22Z",
    transform: "translate(-527.509 -145.65)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M533.831,194.348v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-527.509 -145.404)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666",
    transform: "translate(8.913 2.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M551.4,167.443l15.1-8.721L551.4,150l-15.1,8.721Z",
    transform: "translate(-536.3 -150)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M536.3,158.307v1.061l15.1,8.72v-1.06Z",
    transform: "translate(-536.3 -149.584)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M565.786,158.307v1.061l-15.1,8.721v-1.06Z",
    transform: "translate(-535.579 -149.584)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671",
    transform: "translate(17.059 6.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667",
    transform: "translate(6.091 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M556.566,158.647l.669-.383-.055-.314-6.209-3.611-.862.411.161.268Z",
    transform: "translate(-549.841 -154.127)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M550.955,154.636l-.668.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-549.856 -154.135)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668",
    transform: "translate(4.062 1.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M554.634,159.76l.669-.383-.055-.314-6.209-3.611-.862.411.161.268Z",
    transform: "translate(-547.91 -155.24)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M549.022,155.748l-.668.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-547.924 -155.247)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669",
    transform: "translate(2.031 2.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M552.7,160.872l.669-.383-.055-.314-6.209-3.611-.862.411.16.268Z",
    transform: "translate(-545.976 -156.353)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M547.089,156.862l-.668.383L545.99,157l1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-545.99 -156.361)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670",
    transform: "translate(0 3.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M550.765,161.988l.669-.383-.055-.314-6.209-3.611-.862.411.16.268Z",
    transform: "translate(-544.041 -157.467)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M545.154,157.975l-.668.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-544.056 -157.474)",
    fill: "#12594f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673",
    transform: "translate(24.838 24.565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M551.465,172.679a1.829,1.829,0,0,1,.829-1.434.579.579,0,0,1,.588-.057h0l.586.343-.363.012a.961.961,0,0,1,.016.179,1.831,1.831,0,0,1-.828,1.434.956.956,0,0,1-.178.077l.169.316-.574-.336h0A.579.579,0,0,1,551.465,172.679Z",
    transform: "translate(-551.462 -171.133)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M552.028,173.007c0,.528.371.741.829.478a1.832,1.832,0,0,0,.827-1.434c0-.528-.371-.743-.827-.479A1.832,1.832,0,0,0,552.028,173.007Z",
    transform: "translate(-551.435 -171.116)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M552.363,172.783c0,.307.213.428.477.275a1.055,1.055,0,0,0,.476-.826c0-.307-.213-.426-.476-.275a1.053,1.053,0,0,0-.477.826Z",
    transform: "translate(-551.418 -171.094)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674",
    transform: "translate(42.296 13.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M568.09,162.463a1.833,1.833,0,0,1,.829-1.434.581.581,0,0,1,.588-.056h0l.587.343-.363.012a.946.946,0,0,1,.017.179,1.83,1.83,0,0,1-.829,1.434.965.965,0,0,1-.178.077l.169.316-.574-.336h0A.577.577,0,0,1,568.09,162.463Z",
    transform: "translate(-568.087 -160.918)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M568.654,162.792c0,.528.371.743.828.479a1.83,1.83,0,0,0,.829-1.434c0-.528-.371-.743-.829-.479A1.832,1.832,0,0,0,568.654,162.792Z",
    transform: "translate(-568.06 -160.901)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M568.989,162.568c0,.307.213.428.476.275a1.054,1.054,0,0,0,.477-.826c0-.307-.213-.428-.477-.275A1.056,1.056,0,0,0,568.989,162.568Z",
    transform: "translate(-568.043 -160.879)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675",
    transform: "translate(24.838 65.886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M551.465,212.029a1.829,1.829,0,0,1,.829-1.434.579.579,0,0,1,.588-.057h0l.586.343-.363.012a.961.961,0,0,1,.016.179,1.831,1.831,0,0,1-.828,1.434.957.957,0,0,1-.178.077l.169.316-.574-.336h0A.579.579,0,0,1,551.465,212.029Z",
    transform: "translate(-551.462 -210.483)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M552.028,212.352c0,.528.371.741.829.478a1.832,1.832,0,0,0,.827-1.434c0-.528-.371-.743-.827-.479a1.83,1.83,0,0,0-.829,1.436Z",
    transform: "translate(-551.435 -210.465)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M552.363,212.129c0,.307.213.428.477.275a1.055,1.055,0,0,0,.476-.826c0-.307-.213-.426-.476-.275a1.053,1.053,0,0,0-.477.826Z",
    transform: "translate(-551.418 -210.443)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676",
    transform: "translate(42.297 55.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M568.09,201.808a1.833,1.833,0,0,1,.829-1.434.581.581,0,0,1,.588-.056h0l.587.343-.363.012a.956.956,0,0,1,.017.179,1.83,1.83,0,0,1-.829,1.434.962.962,0,0,1-.178.077l.169.315-.574-.335h0A.58.58,0,0,1,568.09,201.808Z",
    transform: "translate(-568.087 -200.263)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M568.654,202.137c0,.528.371.743.828.479a1.83,1.83,0,0,0,.829-1.434c0-.528-.371-.743-.829-.479A1.832,1.832,0,0,0,568.654,202.137Z",
    transform: "translate(-568.06 -200.246)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M568.989,201.913c0,.307.213.426.476.275a1.054,1.054,0,0,0,.477-.826c0-.307-.213-.428-.477-.275A1.056,1.056,0,0,0,568.989,201.913Z",
    transform: "translate(-568.043 -200.224)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691",
    transform: "translate(37.165 21.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M587.061,192.44l20.818-12.019L587.061,168.4l-20.818,12.019Z",
    transform: "translate(-563.048 -168.4)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M586.387,246.29l-22.773-13.147a.824.824,0,0,1,0-1.427l22.773-13.147a1.667,1.667,0,0,1,1.663,0l22.772,13.147a.823.823,0,0,1,0,1.426L588.048,246.29a1.668,1.668,0,0,1-1.661,0Zm.3-27.2-22.773,13.147a.222.222,0,0,0,0,.383l22.772,13.147a1.063,1.063,0,0,0,1.059,0l22.773-13.149a.222.222,0,0,0,0-.383l-22.772-13.142a1.061,1.061,0,0,0-1.059,0Z",
    transform: "translate(-563.202 -165.895)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678",
    transform: "translate(6.379 56.353)",
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M586.914,242.432l17.642-10.184-17.639-10.184-17.64,10.185Z",
    transform: "translate(-569.277 -222.064)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M587.061,236.374l20.818-12.019-20.818-12.019-20.818,12.019Z",
    transform: "translate(-563.048 -166.198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M566.248,179.848v46.136L587.062,238V191.867Z",
    transform: "translate(-563.049 -167.827)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M606.889,179.848v46.136L586.071,238V191.867Z",
    transform: "translate(-562.055 -167.827)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M569.221,190.463v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-562.9 -167.295)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M569.221,195.373v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-562.9 -167.048)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M569.221,200.283v1.22l14.572,8.413V208.7Z",
    transform: "translate(-562.9 -166.802)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M569.221,205.192v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-562.9 -166.556)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M569.221,210.1v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-562.9 -166.309)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M569.221,215.012v1.217l14.572,8.413v-1.22Z",
    transform: "translate(-562.9 -166.064)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 21.171,
    height: 18.651,
    transform: "translate(23.867 2.285)",
    opacity: 0.78,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABKCAYAAAAlt3MqAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOTSURBVHhe7dxNSBRhHMfxn3YKgk5F0MFOdohAKAgrEkoKJHsVfH83tcU0EfNldXXV1UzENDG1MvM9sFfDyrTaCiUoEKJDnvIQRJ2CoFNt86z/ia182XVnZ+aZeT7U7vNbO32bXS/LBMWWumagkJEGhNPRtILpWRFxZVDsP4dXil6hxMUepKt1t3uZjKJXqCfpap2OL8c0TdMIWFCZ2aIG7C3PBAXRYYFruB576GxYqgalZxg5rCZB5deHHMYLG/DP0OUkWPGKjoahaVCGRU2swEua3NP0LS9xvyZt9uxiLw/UYR97jVeaX6H/SqrEi+RKOGlyR3dBZck2PKcjV3QblEmx4VlqFZ7S5IKug8pSqzGVVo1JmrrGRVBZuh1P6KhbXAVlMmowkVmLRzR1h7ugsqw6PDzlwDhN3eA2qCy7Hg9yGjBGU3PcB5WdbsRdOmrKMEEZywXczmvCKE1NGCqoLL8ZNwtaMExTVYYMKiu8iMGiNvTRVIWhg8qK23GdjgFniqBMSQeulneii2bAmCaorKIbHVXX0EpTcaYLKqvpRbOjH400FWPaoLLzg3DQURGmD8o0jcDeMopKmn4RQT203ZF+d91HEc1VEUEX0T2OM3T0mQi6hJ7HyO2bQgZNr4mgKxhyIunWDGJorkgE9dK9N4gen8VBmksSQX00+R4RdFyUCLoKzjnsmvmIMJp/EUH98PYTtr77ihCabiKoAua+YeP8D6xjZxFUQZ9/YY0IqqBNwfgpgiogdD2+hKzFd3YWQf20fQPm6egmgq5S+BbM7tiMDzT/EEF9FLkNzohQvKb5HxHUS0d3YiwqDBM0lySCeuFkuPdfnhBBl5FyAD0JERig6RURdBHZUbiUcQidNH0ignrIP45GyxE001wVEZQUxqCWjn4xfdDSRFiL41BF02+mDWpLQ5E1GSU0FWPKoPZMFNBRcaYKWp+LnLpsWGgGhCmCNuUhvdGCLJoBZeigLWeR2JyPFJqqMGzQ1kLE01FVhgvaXoyYtiLE0lSdYYJeLsGxjnM4QVMz3AftLsfhrjJE09Qc10GvWBFFR93Q3S0yID1If1zSA9su9888zuxvj23l7xhphaugvdWIZP9Ez7gIesOO/exHPND9ZyhPMRndXqH9tct/bVCvxH2bFKartzzvMRldXKFDDux1LwPQNKgR786oSVAj3z9U9c9Qo9/lVrUrVAppiruGBzyoWUIuAH4D5IsRe2gX4BkAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680",
    transform: "translate(8.911 2.379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M586.793,188.109l15.1-8.721-15.1-8.72-15.1,8.721Z",
    transform: "translate(-571.689 -170.667)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M571.688,178.971v1.061l15.1,8.72v-1.06Z",
    transform: "translate(-571.688 -170.251)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M601.177,178.971v1.06l-15.1,8.721v-1.06Z",
    transform: "translate(-570.968 -170.251)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685",
    transform: "translate(17.06 6.721)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681",
    transform: "translate(6.091 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M591.957,179.311l.669-.383-.055-.314L586.362,175l-.862.411.161.268Z",
    transform: "translate(-585.233 -174.792)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M586.346,175.3l-.668.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-585.247 -174.8)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682",
    transform: "translate(4.06 1.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M590.023,180.424l.669-.383-.055-.314-6.209-3.611-.862.411.161.268Z",
    transform: "translate(-583.299 -175.905)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M584.412,176.414l-.669.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-583.313 -175.913)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683",
    transform: "translate(2.03 2.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M588.089,181.537l.669-.383-.056-.314-6.209-3.611-.862.411.161.268Z",
    transform: "translate(-581.366 -177.018)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M582.479,177.527l-.668.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-581.38 -177.026)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684",
    transform: "translate(0 3.505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M586.156,182.65l.669-.383-.056-.314-6.209-3.611-.862.411.161.268Z",
    transform: "translate(-579.433 -178.13)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M580.545,178.639l-.668.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-579.447 -178.138)",
    fill: "#12594f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687",
    transform: "translate(24.837 24.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M586.855,193.343a1.829,1.829,0,0,1,.829-1.434.578.578,0,0,1,.588-.057h0l.587.343-.363.012a.948.948,0,0,1,.017.179,1.829,1.829,0,0,1-.829,1.434.842.842,0,0,1-.178.077l.169.316-.574-.336h0A.581.581,0,0,1,586.855,193.343Z",
    transform: "translate(-586.852 -191.797)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M587.418,193.672c0,.528.372.743.829.478a1.829,1.829,0,0,0,.829-1.434c0-.528-.371-.743-.829-.478a1.831,1.831,0,0,0-.829,1.434Z",
    transform: "translate(-586.825 -191.78)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M587.753,193.446c0,.307.215.428.477.275a1.05,1.05,0,0,0,.479-.825c0-.307-.213-.428-.477-.275A1.053,1.053,0,0,0,587.753,193.446Z",
    transform: "translate(-586.808 -191.758)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688",
    transform: "translate(42.297 13.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M603.481,183.129a1.829,1.829,0,0,1,.829-1.434.579.579,0,0,1,.588-.057h0l.586.343-.363.012a.971.971,0,0,1,.016.179,1.83,1.83,0,0,1-.828,1.434.928.928,0,0,1-.178.077l.169.316-.574-.336h0A.581.581,0,0,1,603.481,183.129Z",
    transform: "translate(-603.478 -181.583)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M604.044,183.457c0,.528.371.741.829.478a1.834,1.834,0,0,0,.829-1.434c0-.528-.372-.743-.829-.478A1.829,1.829,0,0,0,604.044,183.457Z",
    transform: "translate(-603.451 -181.566)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M604.379,183.229c0,.307.213.428.477.275a1.055,1.055,0,0,0,.477-.826c0-.307-.214-.426-.477-.275A1.053,1.053,0,0,0,604.379,183.229Z",
    transform: "translate(-603.434 -181.543)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689",
    transform: "translate(24.837 65.886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M586.855,232.688a1.829,1.829,0,0,1,.829-1.434.579.579,0,0,1,.588-.057h0l.587.343-.363.012a.948.948,0,0,1,.017.179,1.829,1.829,0,0,1-.829,1.434.842.842,0,0,1-.178.077l.169.316-.574-.336h0A.581.581,0,0,1,586.855,232.688Z",
    transform: "translate(-586.852 -231.142)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M587.418,233.017c0,.528.372.743.829.478a1.829,1.829,0,0,0,.829-1.434c0-.528-.371-.743-.829-.478a1.831,1.831,0,0,0-.829,1.434Z",
    transform: "translate(-586.825 -231.125)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M587.753,232.792c0,.307.215.428.477.275a1.05,1.05,0,0,0,.477-.826c0-.307-.213-.426-.477-.275A1.056,1.056,0,0,0,587.753,232.792Z",
    transform: "translate(-586.808 -231.103)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690",
    transform: "translate(42.297 55.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M603.481,222.473a1.829,1.829,0,0,1,.829-1.434.579.579,0,0,1,.588-.057h0l.586.343-.363.011a.951.951,0,0,1,.016.179,1.83,1.83,0,0,1-.828,1.434.926.926,0,0,1-.178.077l.169.316-.574-.336h0A.581.581,0,0,1,603.481,222.473Z",
    transform: "translate(-603.478 -220.927)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M604.044,222.8c0,.527.371.741.829.478a1.834,1.834,0,0,0,.829-1.434c0-.528-.372-.743-.829-.479A1.832,1.832,0,0,0,604.044,222.8Z",
    transform: "translate(-603.451 -220.91)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M604.379,222.577c0,.307.213.428.477.275a1.055,1.055,0,0,0,.477-.826c0-.307-.214-.426-.477-.275A1.053,1.053,0,0,0,604.379,222.577Z",
    transform: "translate(-603.434 -220.888)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705",
    transform: "translate(74.33 43.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M622.457,213.1l20.818-12.019-20.814-12.019-20.818,12.019Z",
    transform: "translate(-598.44 -189.067)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M621.777,266.959,599,253.812a.823.823,0,0,1,0-1.426l22.775-13.149a1.664,1.664,0,0,1,1.661,0l22.773,13.147a.823.823,0,0,1,0,1.426l-22.773,13.149A1.663,1.663,0,0,1,621.777,266.959Zm.3-27.2L599.3,252.907a.222.222,0,0,0,0,.383l22.773,13.147a1.061,1.061,0,0,0,1.059,0l22.773-13.147a.222.222,0,0,0,0-.383l-22.773-13.147a1.059,1.059,0,0,0-1.059,0Z",
    transform: "translate(-598.592 -186.564)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692",
    transform: "translate(6.378 56.352)",
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M622.3,263.1l17.64-10.185L622.3,242.729l-17.639,10.185Z",
    transform: "translate(-604.665 -242.729)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M622.457,257.038l20.818-12.019L622.461,233l-20.818,12.019Z",
    transform: "translate(-598.44 -186.864)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M601.638,200.513V246.65l20.817,12.019V212.531Z",
    transform: "translate(-598.439 -188.493)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M642.28,200.512V246.65l-20.818,12.019V212.531Z",
    transform: "translate(-597.446 -188.493)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M604.612,211.127v1.22l14.572,8.413v-1.221Z",
    transform: "translate(-598.29 -187.961)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M604.612,216.037v1.22l14.572,8.411v-1.22Z",
    transform: "translate(-598.29 -187.715)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M604.612,220.947v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-598.29 -187.469)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M604.612,225.857v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-598.29 -187.223)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M604.612,230.767v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-598.29 -186.977)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M604.612,235.676v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-598.29 -186.73)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 20.919,
    height: 18.651,
    transform: "translate(24.003 2.257)",
    opacity: 0.78,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFMAAABKCAYAAADHa2hTAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOOSURBVHhe7dxNSBRhHMfxnxJdutQpKrp4qg4FRURpb2JkiBhCaVq+ZaaZuZi0rqapu7oZm6yZaWWm+ZIWSWKWoUlQFhEFdahOXiKiU126RLjNs/1HzHzZl9mZeWaez2X+/9k9fXnG0zphSSWel1BArxNbaTQtxWISjxR1G82mE05XxSTb8IJG01E8JsOCHio1X1TFH3O6IiyMBsntWnM8+iE5mTNJp3ScRkNT5WRKpu5LpzSSRsNR5WROx05pSpkxT6rqJ5OZ9pmnpwZRNHNP9ZM5U2oZntHIPc1PpjR68Hf3dDuwwztxSlcx6b6ny46d3okzuowpXdn3PZ3V2O29wwnN/2bOJ+0cxmjkgq5jMulS0PRKPKFV13QfU5ZZhZHMaozQqkvcxJRl2fH4qB2PaNUV7mLKsh14SKNucBuTyanBg+NODNKqOa5jynLPYyCvDvdp1YwhYsryL+AejZowVEzmpAt3T11EH62qMlxMmcWN7qIGdNKqCsPGlBU3ot3ahDZaQ8rwMWW2ZlynMWRME5Mpu4bmilY00qo4U8WUVbbBbe+Ai1bFmDKmrLYLdXU9cNAaNFPHlNXfQQWNQRExSUM/bE0DKKY1ICLmDC1DsLQO4wStfhEx59A+imwafSZizqP7KdL6niOZ1gWJmD7of4XEwTeIo3VOIqYfht8jZuwjttP6HxEzAOMT2EjjP0TMAL3+jHXvviGCVi8RM0ifvmPFxE8sZbOIqZAvv7FYxFSQiKmAiCX4sWoRfomYQdiwHBNrluErreJkBiIyAm83r8YHWqeImH6KXjv3L51FTB/Fb8JQ7HqM0jorEXMBSVHoTdyCflrnJWLOI3UXbtHoExFzFtmxuJIRg1ZafSZiTpOfAFduHNy0+k3ElBQdRHVhIpy0Bsz0Ma0pOEtj0EwbszwdxaWHYaVVEaaLWZ2NgsosWGhVlGliOvNwrCYHebSGhCli1uUji8aQMnTM+kIccRUgg9aQM2TMS6eR5LYglVbVGC3mysvFOECz6gwTs9mK/U1ntH3rF/cxr9oQ31KCBFo1pev/N2dX7y3pGh6GSfY96d6kdJm8UY597CM94fJk6jEkw1XMmxXY01aOvbTqDhePeUcVor2f6Jx4R4eCdPuY8xaS0d3J7LLz+24j3cTsdsz9I1JeaB5TvAtOIUYKyWhyMo36Dk1VYxr5RaSMao+50UMyIT+ZZnl5MwD8AXedGGxm/mafAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694",
    transform: "translate(8.911 2.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M622.183,208.773l15.1-8.721-15.1-8.72-15.1,8.721Z",
    transform: "translate(-607.079 -191.331)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M607.078,199.636v1.06l15.1,8.72v-1.061Z",
    transform: "translate(-607.078 -190.915)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M636.567,199.635V200.7l-15.1,8.721v-1.061Z",
    transform: "translate(-606.358 -190.915)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699",
    transform: "translate(17.059 6.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695",
    transform: "translate(6.092 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M627.347,199.975l.669-.383-.055-.314-6.209-3.611-.862.411.16.268Z",
    transform: "translate(-620.623 -195.456)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M621.736,195.965l-.668.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-620.637 -195.464)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696",
    transform: "translate(4.062 1.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M625.414,201.088l.669-.383-.055-.314-6.209-3.611-.862.411.16.268Z",
    transform: "translate(-618.691 -196.568)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M619.8,197.078l-.668.383-.431-.249,1.1-.635,6.723,3.882-.431.249Z",
    transform: "translate(-618.705 -196.577)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697",
    transform: "translate(2.028 2.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M623.48,202.2l.669-.383-.055-.314-6.209-3.611-.862.411.161.268Z",
    transform: "translate(-616.754 -197.681)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M617.865,198.191l-.668.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-616.767 -197.69)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698",
    transform: "translate(0 3.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M621.546,203.314l.669-.383-.055-.314-6.209-3.611-.862.411.161.268Z",
    transform: "translate(-614.822 -198.795)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M615.936,199.3l-.669.383-.431-.249,1.1-.635,6.723,3.882-.431.249Z",
    transform: "translate(-614.837 -198.803)",
    fill: "#12594f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701",
    transform: "translate(24.838 24.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M622.246,214.007a1.832,1.832,0,0,1,.827-1.434.582.582,0,0,1,.589-.056h0l.586.343-.363.012a.956.956,0,0,1,.016.179,1.832,1.832,0,0,1-.829,1.434.953.953,0,0,1-.176.077l.169.315-.574-.336h0A.58.58,0,0,1,622.246,214.007Z",
    transform: "translate(-622.243 -212.462)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M622.809,214.336c0,.528.371.743.829.479a1.835,1.835,0,0,0,.827-1.436c0-.528-.371-.741-.827-.478A1.83,1.83,0,0,0,622.809,214.336Z",
    transform: "translate(-622.216 -212.445)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M623.144,214.112c0,.307.213.426.477.275a1.056,1.056,0,0,0,.477-.826c0-.307-.214-.428-.477-.275A1.05,1.05,0,0,0,623.144,214.112Z",
    transform: "translate(-622.199 -212.423)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702",
    transform: "translate(42.297 13.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M638.872,203.792a1.83,1.83,0,0,1,.828-1.434.578.578,0,0,1,.588-.057h0l.587.343-.363.012a.954.954,0,0,1,.016.179,1.829,1.829,0,0,1-.829,1.434.844.844,0,0,1-.178.077l.169.316-.574-.336h0A.578.578,0,0,1,638.872,203.792Z",
    transform: "translate(-638.869 -202.246)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M639.435,204.121c0,.528.371.743.828.478a1.829,1.829,0,0,0,.829-1.434c0-.528-.371-.743-.829-.478A1.83,1.83,0,0,0,639.435,204.121Z",
    transform: "translate(-638.842 -202.229)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M639.77,203.895c0,.307.213.428.476.275a1.05,1.05,0,0,0,.477-.826c0-.307-.213-.426-.477-.274A1.052,1.052,0,0,0,639.77,203.895Z",
    transform: "translate(-638.825 -202.207)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703",
    transform: "translate(24.838 65.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M622.246,253.352a1.832,1.832,0,0,1,.827-1.434.58.58,0,0,1,.589-.056h0l.586.343-.362.012a.953.953,0,0,1,.016.179,1.832,1.832,0,0,1-.829,1.436.954.954,0,0,1-.176.077l.169.315-.574-.335h0A.58.58,0,0,1,622.246,253.352Z",
    transform: "translate(-622.243 -251.807)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M622.809,253.681c0,.528.371.743.829.478a1.831,1.831,0,0,0,.827-1.434c0-.528-.371-.743-.827-.478a1.829,1.829,0,0,0-.829,1.434Z",
    transform: "translate(-622.216 -251.79)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M623.144,253.457c0,.307.213.426.477.275a1.056,1.056,0,0,0,.477-.826c0-.307-.214-.428-.477-.275A1.05,1.05,0,0,0,623.144,253.457Z",
    transform: "translate(-622.199 -251.768)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704",
    transform: "translate(42.297 55.157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M638.872,243.137a1.83,1.83,0,0,1,.828-1.434.578.578,0,0,1,.588-.057h0l.587.343-.363.012a.953.953,0,0,1,.016.179,1.829,1.829,0,0,1-.829,1.434.846.846,0,0,1-.178.077l.169.316-.574-.336h0A.579.579,0,0,1,638.872,243.137Z",
    transform: "translate(-638.869 -241.591)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M639.435,243.466c0,.528.371.743.828.478a1.829,1.829,0,0,0,.829-1.434c0-.528-.371-.743-.829-.478A1.83,1.83,0,0,0,639.435,243.466Z",
    transform: "translate(-638.842 -241.574)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M639.77,243.24c0,.307.213.428.476.275a1.051,1.051,0,0,0,.477-.824c0-.307-.213-.428-.477-.275A1.052,1.052,0,0,0,639.77,243.24Z",
    transform: "translate(-638.825 -241.552)",
    fill: "#14e2c5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720",
    transform: "translate(0 25.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M511.592,195.637l20.818-12.019L511.593,171.6l-20.818,12.019Z",
    transform: "translate(-487.576 -171.6)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M510.914,249.49l-22.773-13.147a.823.823,0,0,1,0-1.426l22.775-13.149a1.664,1.664,0,0,1,1.661,0l22.773,13.147a.823.823,0,0,1,0,1.426L512.576,249.49A1.67,1.67,0,0,1,510.914,249.49Zm.3-27.2-22.775,13.147a.222.222,0,0,0,0,.383l22.773,13.147a1.061,1.061,0,0,0,1.059,0l22.773-13.149a.221.221,0,0,0,0-.383L512.275,222.29a1.059,1.059,0,0,0-1.059,0Z",
    transform: "translate(-487.729 -169.095)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707",
    transform: "translate(6.375 56.351)",
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M511.44,245.628l17.64-10.185L511.441,225.26,493.8,235.444Z",
    transform: "translate(-493.8 -225.26)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M511.592,239.57l20.818-12.019-20.817-12.019-20.818,12.019Z",
    transform: "translate(-487.576 -169.397)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M490.775,183.044V229.18L511.592,241.2V195.063Z",
    transform: "translate(-487.576 -171.026)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M531.416,183.044V229.18L510.6,241.2V195.063Z",
    transform: "translate(-486.583 -171.026)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M493.749,193.659v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-487.427 -170.494)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M493.749,198.569v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-487.427 -170.247)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M493.749,203.479v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-487.427 -170.002)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M493.749,208.389v1.22l14.572,8.413V216.8Z",
    transform: "translate(-487.427 -169.756)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M493.749,213.3v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-487.427 -169.51)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M493.749,218.208v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-487.427 -169.263)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_298",
    "data-name": "Rectangle 298",
    width: 20.919,
    height: 18.903,
    transform: "translate(23.986 2.202)",
    opacity: 0.78,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFMAAABLCAYAAAAMN7v2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAORSURBVHhe7dxLSFRRHMfx30S0aVOriKCFtKhFtYiQHpaEhGCSKDGmpmZmmllW4mvK92jKVJaZZiJmakoohllSZoKPkGhRLWoRLoKIVrVpE8E09/q/kKLjPO7ce84957Pwnt/o6svc2Thcm73Y/QZB6qvDHjoKTZeYGtGj6hqTuD1R99JZKKvoqqvEEswcL8UMTWGEJKZGtKAhuc2VHzabeta4H9ViH50ty7CYdIWVo4b0Nl+K59afTnJgmqalGB5TY8WgpsVUeIJOJTswSZN7hn9mKv77ndtzdGN+u3tqcEA9cYqpmPS6u7saB9UTZ0y9zZdzogwTdOQKkzEVnqCvU8sxTpMLzMbUpHmCplXgFU2mMR9Tk16JMToyi5uYipOVeJlRhRc0mcNVTM2pajzPrMEzmszgMqYmy4mnZ+owTNN0XMfUZF/DEzqayhIxFTn1GMptwABNU1gmpuacC4/PX0c/TUNZLqYm/yZ6L91CN01DWDampqAJnXQMOcvHVBQ1o6OkBfdphowQMTWONrSUtaOJpu6Eiqmp6EBj9QO4aOpGyJia2m7U01EXQsdU1PeixtWPcppBET6mpnEAjqYhFNIMiIy5SOsI8unoNxlzCe2jONs5hkyaPpMxveiZQGr/FBJprkjG9MHgLOKH3yGG5rJkTD+MfkAUHZckY/pp/BMiJr9gN80FZMwAzX7F9vc/EEZTJWMG6fNPbJz7jXXKWcbUybe/WCNj6kjG1EHYWvzatBp/ZMwgbV2P73SU78xAhW/Gx50bMEdTJWP66dA2TEZswVuaC8iYPordhZHoHd6/PCZj+iA+HIN09ErG9CI5El32/eijuSIZcwmZ0bibHoV2mj6TMRfJjkEjHf0mY5L8BDjz4tBAMyDCxyxKwpUCOyppBkXYmFfTUFCagiKauhAyZkVG4P+B9EaomM4s5FRlIo+m7oSIWZ+LjLocnKYZMpaOeeMCUlx5SKcZcpaN2XgRSXQ0jOVi3inAsduXYadpKMvEbClCXHMhEmiagvuY90oQ21qMozRNxXXMNgeO0JEJTD4JwXNV/l69qi8p1/mzeu0ow2HlZdZwFbOz3Pt3fczGzW3OekgF8+/MrkocUl/lALMxH1YhUl0cYS5mdzW/zzZi6jOT55AKJt6ZPU5E0OaaqTF7ndZ6/KMpMa36DE3DPzOt/DBSw96Z8jG5gVkQ0xNRmMeMh/I2t4kUEgD+AVYRGtxOD/+xAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709",
    transform: "translate(8.911 2.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M511.32,191.3l15.1-8.721-15.1-8.72-15.1,8.721Z",
    transform: "translate(-496.216 -173.863)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M496.215,182.168v1.06l15.1,8.72v-1.061Z",
    transform: "translate(-496.215 -173.447)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M525.7,182.167v1.061l-15.1,8.721v-1.061Z",
    transform: "translate(-495.494 -173.447)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714",
    transform: "translate(17.059 6.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710",
    transform: "translate(6.092 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M516.484,182.507l.669-.383-.055-.314-6.209-3.611-.862.411.161.268Z",
    transform: "translate(-509.76 -177.987)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M510.873,178.5l-.668.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-509.774 -177.996)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711",
    transform: "translate(4.062 1.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M514.551,183.62l.669-.383-.055-.314-6.209-3.611-.862.411.16.268Z",
    transform: "translate(-507.828 -179.1)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M508.94,179.61l-.668.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-507.842 -179.109)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712",
    transform: "translate(2.031 2.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M512.617,184.733l.669-.383-.055-.314-6.209-3.611-.862.411.16.268Z",
    transform: "translate(-505.894 -180.214)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M507.006,180.723l-.668.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-505.908 -180.222)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713",
    transform: "translate(0 3.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M510.683,185.846l.669-.383-.055-.314-6.209-3.611-.862.41.16.268Z",
    transform: "translate(-503.959 -181.327)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M505.072,181.836l-.668.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-503.974 -181.335)",
    fill: "#12594f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716",
    transform: "translate(24.838 24.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M511.383,196.539a1.832,1.832,0,0,1,.827-1.434.58.58,0,0,1,.589-.057h0l.586.343-.363.012a.948.948,0,0,1,.016.179,1.829,1.829,0,0,1-.829,1.434.929.929,0,0,1-.176.081l.169.315-.574-.336h0A.578.578,0,0,1,511.383,196.539Z",
    transform: "translate(-511.38 -194.993)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M511.946,196.868c0,.528.371.743.829.478a1.831,1.831,0,0,0,.828-1.434c0-.528-.371-.743-.828-.478A1.829,1.829,0,0,0,511.946,196.868Z",
    transform: "translate(-511.352 -194.976)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M512.281,196.644c0,.307.213.426.477.275a1.055,1.055,0,0,0,.476-.826c0-.307-.213-.428-.476-.275A1.05,1.05,0,0,0,512.281,196.644Z",
    transform: "translate(-511.335 -194.954)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717",
    transform: "translate(42.297 13.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M528.008,186.329a1.831,1.831,0,0,1,.829-1.434.579.579,0,0,1,.588-.057h0l.587.343-.363.012a.953.953,0,0,1,.017.179,1.829,1.829,0,0,1-.829,1.434.846.846,0,0,1-.177.077l.169.316-.574-.336h0a.58.58,0,0,1-.246-.534Z",
    transform: "translate(-528.005 -184.783)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M528.572,186.653c0,.528.371.743.827.478a1.829,1.829,0,0,0,.829-1.434c0-.528-.371-.743-.829-.478A1.831,1.831,0,0,0,528.572,186.653Z",
    transform: "translate(-527.978 -184.765)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M528.907,186.429c0,.307.213.428.476.275a1.05,1.05,0,0,0,.477-.826c0-.307-.213-.426-.477-.275A1.056,1.056,0,0,0,528.907,186.429Z",
    transform: "translate(-527.961 -184.743)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718",
    transform: "translate(24.838 65.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M511.383,235.884a1.831,1.831,0,0,1,.827-1.434.58.58,0,0,1,.589-.057h0l.586.343-.363.012a.938.938,0,0,1,.016.179,1.829,1.829,0,0,1-.829,1.434.867.867,0,0,1-.176.077l.169.316-.574-.336h0A.579.579,0,0,1,511.383,235.884Z",
    transform: "translate(-511.38 -234.338)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M511.946,236.213c0,.528.371.743.829.478a1.831,1.831,0,0,0,.828-1.434c0-.528-.371-.743-.828-.478A1.829,1.829,0,0,0,511.946,236.213Z",
    transform: "translate(-511.353 -234.321)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M512.281,235.987c0,.307.213.428.477.276a1.055,1.055,0,0,0,.476-.826c0-.307-.213-.428-.476-.275A1.05,1.05,0,0,0,512.281,235.987Z",
    transform: "translate(-511.336 -234.299)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719",
    transform: "translate(42.297 55.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M528.008,225.669a1.831,1.831,0,0,1,.829-1.434.579.579,0,0,1,.588-.057h0l.587.343-.363.012a.953.953,0,0,1,.017.179,1.829,1.829,0,0,1-.829,1.434.845.845,0,0,1-.177.077l.169.316-.574-.336h0A.58.58,0,0,1,528.008,225.669Z",
    transform: "translate(-528.005 -224.123)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M528.572,226c0,.528.371.743.827.478a1.829,1.829,0,0,0,.829-1.434c0-.528-.371-.743-.829-.478A1.831,1.831,0,0,0,528.572,226Z",
    transform: "translate(-527.978 -224.106)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M528.907,225.773c0,.307.213.428.476.275a1.051,1.051,0,0,0,.477-.826c0-.307-.213-.426-.477-.275A1.055,1.055,0,0,0,528.907,225.773Z",
    transform: "translate(-527.961 -224.084)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734",
    transform: "translate(37.165 46.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M546.983,216.3,567.8,204.282l-20.817-12.019-20.818,12.019Z",
    transform: "translate(-522.967 -192.263)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M546.3,270.155l-22.773-13.147a.823.823,0,0,1,0-1.426l22.773-13.15a1.664,1.664,0,0,1,1.661,0l22.773,13.147a.824.824,0,0,1,0,1.427l-22.773,13.147a1.661,1.661,0,0,1-1.661,0Zm.3-27.2L523.833,256.1a.222.222,0,0,0,0,.383l22.772,13.148a1.061,1.061,0,0,0,1.059,0l22.773-13.148a.222.222,0,0,0,0-.383l-22.771-13.149a1.068,1.068,0,0,0-1.06,0Z",
    transform: "translate(-523.12 -189.759)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721",
    transform: "translate(6.373 56.352)",
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M546.828,266.292l17.64-10.185-17.64-10.184-17.64,10.185Z",
    transform: "translate(-529.188 -245.924)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M546.983,260.235,567.8,248.216,546.984,236.2l-20.818,12.019Z",
    transform: "translate(-522.967 -190.061)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M526.166,203.709v46.136l20.817,12.019V215.727Z",
    transform: "translate(-522.967 -191.689)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M566.807,203.708v46.136l-20.818,12.019V215.728Z",
    transform: "translate(-521.973 -191.689)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M529.139,214.323v1.22l14.572,8.413v-1.218Z",
    transform: "translate(-522.818 -191.157)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M529.139,219.233v1.22l14.573,8.414v-1.22Z",
    transform: "translate(-522.818 -190.911)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M529.139,224.143v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-522.818 -190.664)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M529.139,229.053v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-522.818 -190.418)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M529.139,233.963v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-522.818 -190.172)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M529.139,238.873v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-522.818 -189.926)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_299",
    "data-name": "Rectangle 299",
    width: 21.171,
    height: 18.903,
    transform: "translate(23.869 2.178)",
    opacity: 0.78,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABLCAYAAADu66CPAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOLSURBVHhe7dxLSFRRHMfxn7YKglZF0MJWtohCKAgrkrAHSdlL8IVvMxPTZLDx/X40yWCamJppWT4Ce1lYmVYDmQQFQrTIVS6CqFUQtKrpnul/xWw0Z+bOnXPPPR9i5vzGVl/OuBFuUGyRcwoaGGpEOB1NTbOgKrOHDaZ3zcQV4xUdTUnzG6pw0ju7rTvoaBp+DRoU9Od9sME8YTX/yrsTX2KeXwO63FDi+ly5rTtdS1C63ND5lNs6mVCKSZrC0f2GMvM+dw7UYxedhaD7DV1Iua0v6SiEgN9Q9qJs9u7sr8Nuto2Mq6Cuj5WXm7XGDRvwr7w7SeVwJFXgBU1D4TKoKrkCz+loGFwHZVIq8SylChM0ucd9UFVqFcbTqvGUJrcME1SVXoMxOnLJcEGZjFo8zqzDI5pcMWRQ1cl6jGY14CFNLhg6qOpUI0ZO23CPZkAJEVSVcwF36BgwQgVlcpswnGfHLZq6Ey6oKr8ZgwUX0U9TN8IGVVla0VfYhl6afid8UJW1Hd109CvTBGVKOtBZ1oV2mn5hqqCqyqtoqbkGO01NmTKoqv4GbOf7UU9TE6YOqmoaQjUdfSaDkuZhlLfehZWm12TQBdpHYOkaxRmaHpNBF9HzBNl09IgMuoS+CaQPOJBIc1lk0GW4PYWY+29wmOaSZFAPjE5j//h7RNB0Swb1gmMG2+n4DxnUS1MfEfb2EzbSnCOD+ujdV4TMfMNamjKoVmZ/YNXnX1ghg2pMBtVIyEp8XxeMnzKojzavwWzoanyhKW+oL7auxwc6zpFBvRARitfhGzBN8y8yqAeiwjC2dxMcNN2SQZfhRDiGj2zDA5pLkkH/IyHCs7/ty6CLSD+AjuRI9NBcNhl0gZxo2LOicImmx2RQUhCD2rxjsNH0mgyqKIxDJR19ZuqgpUmwFiWilKYmTBm0OgP5Famw0NSU2YJuqctCDp39wjRBbTnIbMj2/wNmhA9qz0NyUy7SaPqdsEFbChDffNazv6lrQcigrRbE0lF3QgVtP4fjbYWIoRkQQgTtLEb0ZSuO0gwoQwe9UoqorhIcoskFwwbtLsNBOnKFy0dkKP+cygvbTtfP5p17K7GP/TdeGSbo9SpEsh/zjvugfTXYwz42Cq5/hxotJiMfM6QxroKK8CAsbr7yIsRkAn5DRXuYYMCCKiGFfI6o7kHlA1k1JHpMRpcbaqaHWvs1qPkeuw78BqI5FwvTXts3AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723",
    transform: "translate(8.911 2.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M546.711,211.969l15.1-8.721-15.1-8.72-15.1,8.721Z",
    transform: "translate(-531.607 -194.527)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M531.606,202.832v1.06l15.1,8.72v-1.061Z",
    transform: "translate(-531.606 -194.111)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M561.1,202.832v1.061l-15.1,8.721v-1.061Z",
    transform: "translate(-530.886 -194.111)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728",
    transform: "translate(17.06 6.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724",
    transform: "translate(6.091 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M551.874,203.171l.669-.383-.056-.314-6.209-3.611-.862.411.161.268Z",
    transform: "translate(-545.152 -198.652)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M546.265,199.161l-.668.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-545.166 -198.66)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725",
    transform: "translate(4.06 1.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M549.941,204.288l.669-.383-.056-.314-6.209-3.611-.862.41.161.268Z",
    transform: "translate(-543.217 -199.765)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M544.33,200.274l-.668.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-543.231 -199.773)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726",
    transform: "translate(2.029 2.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M548.008,205.4l.669-.383-.056-.314-6.209-3.611-.862.411.161.268Z",
    transform: "translate(-541.284 -200.877)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M542.4,201.387l-.668.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-541.298 -200.886)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727",
    transform: "translate(0 3.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M546.074,206.51l.669-.383-.055-.314-6.209-3.611-.862.411.161.268Z",
    transform: "translate(-539.352 -201.991)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M540.465,202.5l-.668.383-.431-.249,1.1-.634,6.724,3.882-.431.249Z",
    transform: "translate(-539.366 -202)",
    fill: "#12594f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730",
    transform: "translate(24.836 24.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M546.773,217.2a1.83,1.83,0,0,1,.829-1.434.581.581,0,0,1,.588-.056h0l.587.343-.363.012a.941.941,0,0,1,.017.179,1.831,1.831,0,0,1-.829,1.434.972.972,0,0,1-.178.077l.169.315-.574-.335h0A.579.579,0,0,1,546.773,217.2Z",
    transform: "translate(-546.77 -215.658)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M547.336,217.529c0,.528.372.743.829.479a1.83,1.83,0,0,0,.829-1.434c0-.529-.371-.743-.829-.479A1.834,1.834,0,0,0,547.336,217.529Z",
    transform: "translate(-546.743 -215.64)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M547.671,217.308c0,.307.214.428.477.275a1.054,1.054,0,0,0,.477-.826c0-.307-.213-.428-.477-.275A1.056,1.056,0,0,0,547.671,217.308Z",
    transform: "translate(-546.726 -215.619)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731",
    transform: "translate(42.297 13.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M563.4,206.988a1.83,1.83,0,0,1,.829-1.434.581.581,0,0,1,.588-.057h0l.586.343-.363.012a.948.948,0,0,1,.016.179,1.835,1.835,0,0,1-.827,1.436.93.93,0,0,1-.178.077l.169.316-.574-.336h0A.579.579,0,0,1,563.4,206.988Z",
    transform: "translate(-563.396 -205.443)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M563.962,207.317c0,.528.371.743.829.478a1.829,1.829,0,0,0,.829-1.434c0-.528-.371-.743-.829-.478A1.829,1.829,0,0,0,563.962,207.317Z",
    transform: "translate(-563.369 -205.426)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M564.3,207.093c0,.307.213.426.477.275a1.056,1.056,0,0,0,.477-.826c0-.307-.215-.428-.477-.275A1.05,1.05,0,0,0,564.3,207.093Z",
    transform: "translate(-563.353 -205.404)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_732",
    "data-name": "Group 732",
    transform: "translate(24.836 65.886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M546.773,256.548a1.83,1.83,0,0,1,.829-1.434.58.58,0,0,1,.588-.056h0l.587.343-.363.012a.941.941,0,0,1,.017.179,1.831,1.831,0,0,1-.829,1.434.975.975,0,0,1-.178.077l.169.315-.574-.335h0A.579.579,0,0,1,546.773,256.548Z",
    transform: "translate(-546.77 -255.003)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M547.336,256.877c0,.528.372.743.829.479a1.833,1.833,0,0,0,.83-1.436c0-.527-.371-.741-.829-.478a1.834,1.834,0,0,0-.83,1.434Z",
    transform: "translate(-546.743 -254.986)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M547.671,256.653c0,.307.214.426.477.275a1.054,1.054,0,0,0,.477-.826c0-.307-.213-.428-.477-.275a1.055,1.055,0,0,0-.477.826Z",
    transform: "translate(-546.726 -254.964)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(42.296 55.155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M563.4,246.329a1.831,1.831,0,0,1,.829-1.434.579.579,0,0,1,.588-.057h0l.586.343-.363.012a.953.953,0,0,1,.016.179,1.831,1.831,0,0,1-.827,1.434.941.941,0,0,1-.178.08l.169.315-.574-.336h0A.58.58,0,0,1,563.4,246.329Z",
    transform: "translate(-563.396 -244.783)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M563.962,246.662c0,.528.371.743.829.478a1.829,1.829,0,0,0,.829-1.434c0-.528-.371-.743-.829-.478A1.829,1.829,0,0,0,563.962,246.662Z",
    transform: "translate(-563.369 -244.767)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M564.3,246.438c0,.307.213.426.477.275a1.056,1.056,0,0,0,.477-.826c0-.307-.215-.428-.477-.275A1.05,1.05,0,0,0,564.3,246.438Z",
    transform: "translate(-563.352 -244.745)",
    fill: "#14e2c5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_748",
    "data-name": "Group 748",
    transform: "translate(74.33 68.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M582.374,236.966l20.818-12.019-20.817-12.019-20.818,12.019Z",
    transform: "translate(-558.358 -212.928)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M581.695,290.82l-22.773-13.147a.823.823,0,0,1,0-1.426L581.7,263.1a1.67,1.67,0,0,1,1.661,0l22.773,13.149a.823.823,0,0,1,0,1.426L583.357,290.82a1.663,1.663,0,0,1-1.663,0Zm.3-27.2-22.775,13.151a.221.221,0,0,0,0,.383L582,290.3a1.061,1.061,0,0,0,1.059,0l22.774-13.148a.222.222,0,0,0,0-.383L583.056,263.62a1.066,1.066,0,0,0-1.059,0Z",
    transform: "translate(-558.51 -210.424)",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735",
    transform: "translate(6.374 56.35)",
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M582.221,286.956l17.636-10.185-17.639-10.184-17.639,10.185Z",
    transform: "translate(-564.578 -266.588)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M582.374,280.9l20.818-12.019L582.374,256.86l-20.818,12.02Z",
    transform: "translate(-558.357 -210.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M561.556,224.373v46.136l20.817,12.019V236.392Z",
    transform: "translate(-558.357 -212.354)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M602.2,224.373v46.136l-20.818,12.019V236.392Z",
    transform: "translate(-557.363 -212.354)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M564.53,234.988v1.22l14.572,8.413V243.4Z",
    transform: "translate(-558.208 -211.822)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M564.53,239.9v1.22l14.572,8.413v-1.22Z",
    transform: "translate(-558.208 -211.576)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M564.53,244.807v1.221l14.572,8.413v-1.22Z",
    transform: "translate(-558.208 -211.33)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M564.53,249.717v1.22L579.1,259.35v-1.22Z",
    transform: "translate(-558.208 -211.083)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M564.53,254.627v1.22L579.1,264.26v-1.221Z",
    transform: "translate(-558.208 -210.837)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M564.53,259.537v1.22l14.572,8.411v-1.22Z",
    transform: "translate(-558.208 -210.591)",
    fill: "#11ad97"
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_300",
    "data-name": "Rectangle 300",
    width: 20.919,
    height: 18.903,
    transform: "translate(24.006 2.152)",
    opacity: 0.78,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFMAAABLCAYAAAAMN7v2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAONSURBVHhe7dxLbExRHMfx34jY2LASEZtuiAUJEdEiXokmJaSCammpQaseExo1Rms6fRkZTYuqR9OgWkU0mqpHvB+tiJCwEDbdiIgVGxsRdc/1P6IyrZnOvXPPued8Fu753Xb1zanl9azZ1/8MCWqvwWw6Ks2SmJzqUS2Naehn/xhRU82lmBH0tFSWH710VIotN5PxeH4/L1arc0ttj0n6jahpdHYtW/7Mo1m7Hz10dK2k3Ux6mtx6Sx2JST/rb6vCHPPkEkn7M48mO4CnOQE8oSk9R2NyOQfcEVSImIwR9PG6UjymKSVhYnJG0Efry/CQplSEi8kZQR/kHsR9mlIQNiaXJ1FQ4WMyeUHc21iOOzSFJUVMbmMId/IrcJumcKSKyW2qwE1vJW7QFIaUMbktVbhORyFIHZPZWoOugkPopOko6WNyhWFcKzqMqzQd4ZqY3PYIrtAx6VwXk9l5BO2+OrTSTBpXxuR216Ol+BjO0rSdq2NyJQ1o9jfiDE3bKBGTC5xGIx1toVRMpqwJx4LNqKNpKeVichXnEKm+gDBNSygbkwu3obL2MspoJkT5mFx9B/x0HDYd8y8NnSg+2Q0fzbjpmFE03cK2s3fhpRkzHXMIrQ+RS8eY6Jj/cekpsjqeI5PmkHTMGHW9RMatN1hMMyodM04P3iO1pw/TaQ6gYw7Tiw+YQsc/dMwEvP6MlHdfMJ6mjmmFvm8Y8/EHRumYFtIxLTJhJL7rmAmaPBafUkbjKzvrmMM0cyLeThuHPpomHTNOCyahNy0Fr2gOoGPGIX0q7tIxKh0zBpmz0LFsBrppDkrHHELOfJxfMwftNP9LxxzEhsVoomPMdMx/FGSgzpuOEzTjomOSXZmoKVqOCM1hUT5mSTYO7F6NEM2EKB1z/zqU0NESSsYM5sNXmodimpZRKmbVFhSGvNhB03JKxAwXIb+mEJtp2sb1MSM7sIGOtnNtzDofcmp3YT3NpHBdzOPFWHV0D7JoJpVrYjaWYEXDXqyk6QhXxDy5D8vp6CipY54OYOkpP5bRdJyjHzwxz+xJm783nuxn5tN8ZTxHePCT/Z7x7mdzKZaw16KR7maKGpKR5maeC2IRO4pM+Jjny7HQfCsBYWO2hDDfXBIR8v9MGUMyQt3M1krMM0+SEiJmaxXmmm8k52hM/WE9i7gtJJP0m+nmL7wmLab+TK41PCqEZGy9mUZEhb7XDvwCY4sS3n6FtWAAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737",
    transform: "translate(8.914 2.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M582.1,232.633l15.1-8.721-15.1-8.72L567,223.912Z",
    transform: "translate(-567 -215.191)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M567,223.5v1.061l15.1,8.72v-1.06Z",
    transform: "translate(-567 -214.776)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M596.485,223.5v1.06l-15.1,8.721v-1.06Z",
    transform: "translate(-566.279 -214.776)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742",
    transform: "translate(17.058 6.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738",
    transform: "translate(6.093 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M587.265,223.836l.669-.383-.055-.314-6.209-3.611-.862.411.16.268Z",
    transform: "translate(-580.542 -219.316)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M581.654,219.825l-.668.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-580.556 -219.324)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739",
    transform: "translate(4.063 1.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M585.334,224.948l.669-.383-.055-.314-6.209-3.611-.862.411.16.268Z",
    transform: "translate(-578.609 -220.429)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M579.722,220.938l-.668.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-578.623 -220.437)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740",
    transform: "translate(2.031 2.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M583.4,226.061l.669-.383-.055-.314-6.209-3.611-.862.411.161.268Z",
    transform: "translate(-576.674 -221.54)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M577.787,222.048l-.668.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-576.688 -221.547)",
    fill: "#12594f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741",
    transform: "translate(0 3.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M581.464,227.174l.669-.383-.055-.314-6.209-3.611-.862.411.161.268Z",
    transform: "translate(-574.739 -222.655)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M575.853,223.164l-.668.383-.431-.249,1.1-.635,6.724,3.882-.431.249Z",
    transform: "translate(-574.754 -222.663)",
    fill: "#12594f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744",
    transform: "translate(24.838 24.566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M582.164,237.868a1.833,1.833,0,0,1,.829-1.436.581.581,0,0,1,.588-.056h0l.586.343-.363.012a.95.95,0,0,1,.016.179,1.83,1.83,0,0,1-.828,1.434.955.955,0,0,1-.178.077l.169.316-.574-.336h0a.579.579,0,0,1-.246-.534Z",
    transform: "translate(-582.161 -236.321)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M582.727,238.2c0,.528.371.741.829.478a1.832,1.832,0,0,0,.828-1.434c0-.528-.371-.743-.828-.479A1.832,1.832,0,0,0,582.727,238.2Z",
    transform: "translate(-582.134 -236.304)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M583.062,237.972c0,.307.213.428.477.275a1.056,1.056,0,0,0,.477-.826c0-.307-.214-.426-.477-.275a1.055,1.055,0,0,0-.477.826Z",
    transform: "translate(-582.117 -236.282)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745",
    transform: "translate(42.297 13.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M598.79,227.652a1.832,1.832,0,0,1,.827-1.434.58.58,0,0,1,.588-.056h0l.587.343-.363.012a.966.966,0,0,1,.015.179,1.831,1.831,0,0,1-.829,1.434.965.965,0,0,1-.178.077l.169.315-.573-.335h0A.579.579,0,0,1,598.79,227.652Z",
    transform: "translate(-598.787 -226.107)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M599.353,227.981c0,.528.371.743.827.479a1.832,1.832,0,0,0,.829-1.434c0-.528-.371-.743-.829-.479A1.833,1.833,0,0,0,599.353,227.981Z",
    transform: "translate(-598.76 -226.09)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M599.688,227.757c0,.307.213.428.476.275a1.054,1.054,0,0,0,.477-.826c0-.307-.213-.428-.477-.275a1.056,1.056,0,0,0-.476.826Z",
    transform: "translate(-598.743 -226.068)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_746",
    "data-name": "Group 746",
    transform: "translate(24.838 65.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M582.164,277.213a1.829,1.829,0,0,1,.829-1.434.579.579,0,0,1,.588-.057h0l.586.343-.363.012a.951.951,0,0,1,.016.179,1.831,1.831,0,0,1-.828,1.434,1.034,1.034,0,0,1-.178.077l.169.316-.574-.336h0A.578.578,0,0,1,582.164,277.213Z",
    transform: "translate(-582.161 -275.667)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M582.727,277.541c0,.527.371.741.829.478a1.832,1.832,0,0,0,.828-1.434c0-.528-.371-.743-.828-.479A1.832,1.832,0,0,0,582.727,277.541Z",
    transform: "translate(-582.134 -275.65)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M583.062,277.317c0,.307.213.428.477.275a1.055,1.055,0,0,0,.477-.826c0-.307-.214-.426-.477-.275a1.054,1.054,0,0,0-.477.826Z",
    transform: "translate(-582.117 -275.628)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_747",
    "data-name": "Group 747",
    transform: "translate(42.297 55.157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M598.79,267a1.832,1.832,0,0,1,.827-1.434.58.58,0,0,1,.588-.056h0l.587.343-.363.012a.971.971,0,0,1,.015.179,1.831,1.831,0,0,1-.829,1.434.96.96,0,0,1-.178.077l.169.315-.573-.335h0A.576.576,0,0,1,598.79,267Z",
    transform: "translate(-598.787 -265.452)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M599.353,267.329c0,.528.371.743.827.479a1.831,1.831,0,0,0,.829-1.434c0-.529-.371-.743-.829-.479A1.832,1.832,0,0,0,599.353,267.329Z",
    transform: "translate(-598.759 -265.436)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M599.688,267.1c0,.307.213.428.476.275a1.054,1.054,0,0,0,.477-.826c0-.307-.213-.428-.477-.275a1.056,1.056,0,0,0-.476.826Z",
    transform: "translate(-598.742 -265.413)",
    fill: "#14e2c5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750",
    transform: "translate(178.18 145.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M594.352,239.955l4.588-2.649V236.3l-4.588,2.649Z",
    transform: "translate(-583.868 -236.3)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M592.111,241.167l1.652-.954v-1.007l-1.652.954Z",
    transform: "translate(-583.981 -236.154)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M590.375,242.155l1.122-.648V240.5l-1.122.649Z",
    transform: "translate(-584.068 -236.089)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M596.34,240.94l2.5-1.447v-1.007l-2.5,1.443Z",
    transform: "translate(-583.768 -236.189)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M592.755,243.026l3.066-1.768V240.25l-3.066,1.768Z",
    transform: "translate(-583.948 -236.101)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M591.019,243.975l1.123-.648V242.32l-1.123.648Z",
    transform: "translate(-584.036 -235.998)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M589.366,244.929l1.123-.648v-1.007l-1.123.649Z",
    transform: "translate(-584.118 -235.95)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M597,242.733l1.809-1.044v-1.007L597,241.725Z",
    transform: "translate(-583.736 -236.08)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M595.742,243.425l.618-.357v-1.007l-.618.357Z",
    transform: "translate(-583.799 -236.011)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M594.006,244.442l1.122-.649v-1.007l-1.122.649Z",
    transform: "translate(-583.886 -235.974)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M592.363,247.735l6.677-3.855v-1.007l-6.677,3.855Z",
    transform: "translate(-583.968 -235.97)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M590.122,248.891l1.652-.954V246.93l-1.652.954Z",
    transform: "translate(-584.08 -235.766)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M597,247.117l1.809-1.044v-1.007L597,246.109Z",
    transform: "translate(-583.736 -235.86)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M592.956,249.5l3.544-2.046v-1.007l-3.544,2.046Z",
    transform: "translate(-583.938 -235.791)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M591.219,250.435l1.122-.649v-1.007l-1.122.648Z",
    transform: "translate(-584.026 -235.674)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M595.2,250.4l3.7-2.136v-1.007l-3.7,2.136Z",
    transform: "translate(-583.826 -235.75)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M591.98,252.23l2.677-1.545v-1.007l-2.677,1.545Z",
    transform: "translate(-583.987 -235.629)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M589.59,253.586l1.809-1.044v-1.007l-1.809,1.044Z",
    transform: "translate(-584.107 -235.536)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M597.531,251.173l1.25-.722v-1.007l-1.25.722Z",
    transform: "translate(-583.709 -235.639)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M595.29,252.483l1.652-.954v-1.007l-1.652.954Z",
    transform: "translate(-583.821 -235.587)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M592.088,254.36l2.661-1.533V251.82l-2.661,1.533Z",
    transform: "translate(-583.982 -235.523)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M595.075,254.859l3.829-2.211V251.64l-3.829,2.211Z",
    transform: "translate(-583.832 -235.53)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M590.991,257.21l3.587-2.07v-1.007l-3.587,2.07Z",
    transform: "translate(-584.037 -235.406)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M589.254,258.145l1.122-.648V256.49l-1.122.648Z",
    transform: "translate(-584.124 -235.288)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M587.588,259.107l1.122-.649v-1.007l-1.122.649Z",
    transform: "translate(-584.207 -235.239)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M596.536,256.165l2.294-1.325v-1.007l-2.294,1.325Z",
    transform: "translate(-583.759 -235.421)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M587.552,243.84l-3.181,1.84v-1.01l3.181-1.84Z",
    transform: "translate(-584.369 -235.971)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M586.87,246.409l-2.5,1.445v-1.007l2.5-1.443Z",
    transform: "translate(-584.368 -235.844)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M586.179,248.979l-1.809,1.044v-1.007l1.809-1.044Z",
    transform: "translate(-584.368 -235.715)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M587,250.719l-2.631,1.519v-1.007L587,249.712Z",
    transform: "translate(-584.368 -235.627)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M586.179,253.363l-1.809,1.044V253.4l1.809-1.044Z",
    transform: "translate(-584.368 -235.494)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M586.664,255.293l-2.294,1.325v-1.007l2.294-1.325Z",
    transform: "translate(-584.368 -235.399)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M585.619,258.054l-1.25.722v-1.007l1.25-.722Z",
    transform: "translate(-584.368 -235.26)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M586.792,259.6,584.37,261v-1.008l2.422-1.4Z",
    transform: "translate(-584.368 -235.182)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M586.664,261.865l-2.294,1.325v-1.007l2.294-1.325Z",
    transform: "translate(-584.368 -235.069)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M594.94,257.049l.976-.563v-1.008l-.976.563Z",
    transform: "translate(-583.839 -235.338)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M592.181,258.676l2.2-1.268V256.4l-2.2,1.268Z",
    transform: "translate(-583.977 -235.292)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M590.451,266.091l3.706-2.139v-1.007l-3.706,2.139Z",
    transform: "translate(-584.064 -234.964)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M588.034,267.424l1.457-.843v-1.007l-1.457.843Z",
    transform: "translate(-584.185 -234.832)",
    fill: "#42ffff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M399.868,299.758a4.892,4.892,0,0,1-2.445-.653l-9.153-5.284.56-.968,9.153,5.284a3.78,3.78,0,0,0,3.769,0l24.07-13.893.56.968L402.312,299.1a4.894,4.894,0,0,1-2.444.653Z",
    transform: "translate(-281.176 -88.26)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765",
    transform: "translate(0 65.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_764",
    "data-name": "Group 764",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_763",
    "data-name": "Group 763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752",
    transform: "translate(5.123 80.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M369.53,309.216a6.866,6.866,0,0,1-3.431-.92l-74.151-42.81a1.565,1.565,0,0,1,0-2.709L338.3,236.016l.281.161,77.3,44.629a1.564,1.564,0,0,1,0,2.709L372.962,308.3A6.862,6.862,0,0,1,369.53,309.216Zm-31.227-71.9-45.793,26.44a.447.447,0,0,0,0,.774l74.149,42.809a5.756,5.756,0,0,0,5.743,0l42.922-24.781a.446.446,0,0,0,0-.773Z",
    transform: "translate(-291.167 -236.016)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_757",
    "data-name": "Group 757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754",
    transform: "translate(50.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M335.968,221.982l10.33-61.287-.831-.35,1.247-.716v.008a.9.9,0,0,1,.962.066l82.559,47.666a2.331,2.331,0,0,1,1.073,2.1L420.9,271.24a.773.773,0,0,1-.435.629h0l-1.221.705-.21-1.141.071.021-82.06-47.374a2.331,2.331,0,0,1-1.073-2.1Z",
    transform: "translate(-334.667 -159.528)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M426,206.7l1.358-.6a1.866,1.866,0,0,1,.174,1.022L417.117,268.9a.774.774,0,0,1-.435.629h0l-1.221.706-.21-1.141.07.021-4.152-2.4Z",
    transform: "translate(-330.891 -157.191)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M335.806,224.784l82.559,47.665c.638.369,1.184.153,1.3-.5l10.412-61.774a2.33,2.33,0,0,0-1.073-2.1l-82.559-47.666c-.638-.367-1.184-.153-1.3.5l-10.412,61.775a2.332,2.332,0,0,0,1.073,2.1Z",
    transform: "translate(-334.729 -159.491)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753",
    transform: "translate(2.976 4.859)",
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M347.374,164.153l79.58,45.946-9.869,58.182-79.527-45.917Z",
    transform: "translate(-337.558 -164.153)",
    fill: "#11ad97"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_756",
    "data-name": "Group 756",
    transform: "translate(0 65.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M286.331,250.7l4.505,2.353,45.179-26.083a3.282,3.282,0,0,1,2.949.122l77.919,44.985c.747-.417,4.146-2.052,4.146-2.052l-1.65,4.3-.006-.005a.986.986,0,0,1-.46.511L371.332,302.3a3.275,3.275,0,0,1-2.949-.122l-79.738-46.033a1.431,1.431,0,0,1-.669-.711l-.006,0Z",
    transform: "translate(-286.288 -221.24)",
    fill: "#12594f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M287.029,251.7l81.716,47.181a3.362,3.362,0,0,0,3.023.126l48.765-28.155c.775-.448.678-1.227-.218-1.744L338.6,221.925a3.356,3.356,0,0,0-3.021-.126l-48.765,28.155C286.038,250.4,286.136,251.182,287.029,251.7Z",
    transform: "translate(-286.29 -221.5)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M420.536,268.764,371.77,296.919a3.358,3.358,0,0,1-3.023-.126l-81.719-47.184a1.578,1.578,0,0,1-.645-.627c-.236.429-.014.953.645,1.332l81.716,47.181a3.362,3.362,0,0,0,3.023.126l48.765-28.155a.813.813,0,0,0,.428-1.118A1.1,1.1,0,0,1,420.536,268.764Z",
    transform: "translate(-286.29 -220.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M388.447,285.514v-.9c0-.085-.051-.124-.116-.087l-3.161,1.825a.278.278,0,0,0-.114.221v.9c0,.085.051.124.114.087l3.161-1.824a.277.277,0,0,0,.116-.221Z",
    transform: "translate(-281.338 -218.339)",
    fill: "#2859cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M383.945,288.111v-.9c0-.085-.051-.124-.116-.087l-3.161,1.824a.282.282,0,0,0-.116.221v.9c0,.085.052.124.116.087l3.161-1.825A.275.275,0,0,0,383.945,288.111Z",
    transform: "translate(-281.563 -218.209)",
    fill: "#2859cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M406.5,267.863l-67.908-39.207a1.456,1.456,0,0,0-1.463,0l-7.412,4.288-16.771,9.7a.521.521,0,0,0,0,.9l67.878,39.189a1.457,1.457,0,0,0,1.462,0L406.5,268.765a.521.521,0,0,0,0-.9Z",
    transform: "translate(-284.967 -221.15)",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M406.5,268.766l-.242.141L338.591,229.84a1.456,1.456,0,0,0-1.463,0l-23.939,13.85-.244-.141a.521.521,0,0,1,0-.9l24.183-13.99a1.456,1.456,0,0,1,1.463,0L406.5,267.863a.521.521,0,0,1,0,.9Z",
    transform: "translate(-284.967 -221.15)",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_755",
    "data-name": "Group 755",
    transform: "translate(31.342 9.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M334.223,232.094l58.989,34.057,2.623-1.514L336.845,230.58Z",
    transform: "translate(-315.228 -230.58)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M328.1,235.629l55.329,31.944,2.623-1.514-55.329-31.944Z",
    transform: "translate(-315.535 -230.403)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M324.111,237.932l65.143,37.611,2.623-1.514-65.143-37.611Z",
    transform: "translate(-315.735 -230.287)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M320.123,240.238l65.14,37.608,2.623-1.514-65.14-37.612Z",
    transform: "translate(-315.935 -230.171)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M316.135,242.539l65.143,37.611,2.623-1.514-65.143-37.611Z",
    transform: "translate(-316.135 -230.057)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M393.789,266.485,396.412,268l2.623-1.514-2.623-1.514Z",
    transform: "translate(-312.242 -228.856)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M384.979,268.469l5.443,3.143,2.623-1.514-5.443-3.143Z",
    transform: "translate(-312.683 -228.756)",
    fill: "#14e2c5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M335.761,275.953,317.45,265.382a.79.79,0,0,1,0-1.5l12.522-7.229a2.867,2.867,0,0,1,2.592,0l18.31,10.572a.79.79,0,0,1,0,1.5l-12.521,7.229A2.861,2.861,0,0,1,335.761,275.953Z",
    transform: "translate(-284.753 -219.752)",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M350.877,267.84l-18.31-10.572a2.867,2.867,0,0,0-2.592,0L317.453,264.5a1.135,1.135,0,0,0-.449.442c-.189-.361-.045-.767.449-1.054l12.522-7.229a2.867,2.867,0,0,1,2.592,0l18.31,10.572c.494.286.639.69.451,1.054A1.132,1.132,0,0,0,350.877,267.84Z",
    transform: "translate(-284.754 -219.752)",
    fill: "url(#linear-gradient-11)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_762",
    "data-name": "Group 762",
    transform: "translate(53.839 4.859)",
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_761",
    "data-name": "Group 761",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_760",
    "data-name": "Group 760",
    transform: "translate(-2.349 30.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M336.061,223.254l81.72,47.182a3.361,3.361,0,0,0,3.023.126l48.764-28.155c.775-.448.678-1.227-.216-1.744l-81.716-47.181a3.361,3.361,0,0,0-3.023-.125l-48.772,28.152C335.07,221.957,335.167,222.738,336.061,223.254Z",
    transform: "translate(-335.321 -193.057)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M414.975,230.8l-18.31-10.572a.79.79,0,0,1,0-1.5l12.521-7.229a2.868,2.868,0,0,1,2.592,0l18.311,10.572a.79.79,0,0,1,0,1.5L417.57,230.8A2.868,2.868,0,0,1,414.975,230.8Z",
    transform: "translate(-332.273 -192.146)",
    fill: "#333b4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M430.088,222.69l-18.312-10.57a2.868,2.868,0,0,0-2.592,0l-12.521,7.23a1.114,1.114,0,0,0-.449.442c-.19-.361-.045-.767.449-1.054l12.521-7.229a2.868,2.868,0,0,1,2.592,0l18.311,10.572c.494.286.639.69.449,1.054A1.127,1.127,0,0,0,430.088,222.69Z",
    transform: "translate(-332.272 -192.147)",
    fill: "#91afff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_759",
    "data-name": "Group 759",
    transform: "translate(12.049 15.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M440.611,247.479,372.7,208.272a1.457,1.457,0,0,0-1.463,0l-24.183,13.991a.521.521,0,0,0,0,.9l67.877,39.189a1.463,1.463,0,0,0,1.462,0l24.215-13.974a.521.521,0,0,0,0-.9Z",
    transform: "translate(-346.795 -208.074)",
    fill: "#adc8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M440.611,248.382l-.244.141L372.7,209.455a1.462,1.462,0,0,0-1.463,0L347.3,223.306l-.242-.141a.52.52,0,0,1,0-.9l24.183-13.991a1.457,1.457,0,0,1,1.463,0l67.909,39.207a.521.521,0,0,1,0,.9Z",
    transform: "translate(-346.795 -208.074)",
    fill: "#91afff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_758",
    "data-name": "Group 758",
    transform: "translate(4.247 2.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M353.185,220.678l59.16,34.157L410,256.187l-59.16-34.157Z",
    transform: "translate(-350.839 -210.314)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M359.118,217.251l56.231,32.463-2.343,1.353L356.775,218.6Z",
    transform: "translate(-350.541 -210.486)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M416.663,250.475l5.252,3.032-2.343,1.353-5.252-3.032Z",
    transform: "translate(-347.656 -208.821)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M412.246,254.778l3.657,2.111-2.343,1.353-3.657-2.111Z",
    transform: "translate(-347.878 -208.604)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M362.837,215.1l65.682,37.921-2.343,1.353-65.682-37.921Z",
    transform: "translate(-350.355 -210.593)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M366.558,212.956l65.682,37.921L429.9,252.23l-65.682-37.921Z",
    transform: "translate(-350.169 -210.702)",
    fill: "#14e2c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M370.276,210.809l65.682,37.921-2.343,1.353-65.682-37.921Z",
    transform: "translate(-349.982 -210.809)",
    fill: "#14e2c5"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-77",
    transform: "translate(230.498 207.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M18.727,80.108l11.454-6.651a2.812,2.812,0,0,1,2.561,0L44.2,80.108a.786.786,0,0,1,0,1.487L32.742,88.247a2.819,2.819,0,0,1-2.561,0L18.727,81.595a.786.786,0,0,1,0-1.487",
    transform: "translate(-18.196 -40.172)",
    fill: "#6b99d1",
    fillRule: "evenodd",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M18.727,50.2l11.454-6.651a2.815,2.815,0,0,1,2.561,0L44.2,50.2a.787.787,0,0,1,0,1.487L32.742,58.338a2.818,2.818,0,0,1-2.561,0L18.727,51.687a.787.787,0,0,1,0-1.487",
    transform: "translate(-18.196 -23.953)",
    fill: "#dceeff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0 19.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M13.88.557a2.611,2.611,0,0,1,1.281.308L26.615,7.516a.786.786,0,0,1,0,1.487L15.161,15.655a2.82,2.82,0,0,1-2.561,0L1.146,9a.786.786,0,0,1,0-1.487L12.6.865A2.608,2.608,0,0,1,13.88.557m0,.506a2.117,2.117,0,0,0-1.029.24L1.4,7.954c-.206.119-.279.239-.279.306s.073.186.279.306l11.454,6.651a2.324,2.324,0,0,0,2.058,0L26.363,8.566c.206-.119.279-.24.279-.306s-.073-.186-.279-.306L14.909,1.3a2.118,2.118,0,0,0-1.029-.24",
    transform: "translate(-0.615 -0.557)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0 26.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    d: "M.225,11.629a.915.915,0,0,0,.531.744L12.21,19.024a2.59,2.59,0,0,0,1.281.309V7.7A2.587,2.587,0,0,1,12.21,7.4L.756.746A.9.9,0,0,1,.225,0Z",
    transform: "translate(-0.225 -0.003)",
    fill: "#454c5c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    d: "M31.461,71.7a.916.916,0,0,1-.531.744L19.476,79.09A2.59,2.59,0,0,1,18.2,79.4V67.771a2.591,2.591,0,0,0,1.281-.307L30.93,60.813a.9.9,0,0,0,.531-.743Z",
    transform: "translate(-4.93 -33.08)",
    fill: "#464d5c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    d: "M15.524,30.176a17.927,17.927,0,0,0,2.554,3.5c.278.321.406.628.865,1.3a5.055,5.055,0,0,0,1.765,1.636c.615.291.883.3,1,.2.142-.124.078-.292-.188-.458a4.143,4.143,0,0,1-1.168-.914s.563.392.921.6a4.082,4.082,0,0,0,1.013.414c.344.082.735-.27.472-.444s-.515-.236-1.04-.547a4.048,4.048,0,0,1-.772-.585,7.615,7.615,0,0,0,1.128.47,1.708,1.708,0,0,0,.963.08c.167-.038.327-.31-.029-.483a6.133,6.133,0,0,1-1.353-.6c-.41-.283-.66-.54-.563-.565s.325.159.755.213c.411.052.845-.144.856-.378s-.083-.123-.5-.243a10.592,10.592,0,0,0-1.325-.5,4.485,4.485,0,0,1-1.309-.424A10.465,10.465,0,0,1,17.5,29.47a43.891,43.891,0,0,1-1.487-4.752c-.439-1.59-1.041-4.839-1.361-5.94a1.8,1.8,0,0,0-1.493-1.5C12.4,17.1,12,18.059,12.135,18.99c.244,1.634,1.513,7.977,3.389,11.186",
    transform: "translate(6.1 -9.861)",
    fill: "#ffa8a7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    d: "M22.257,47.938l.667.865a1.623,1.623,0,0,1-.776.781c-.649.377-.887.323-.887.323l-.651-.838Z",
    transform: "translate(2.5 -26.501)",
    fill: "#f5fbfb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    d: "M22.481,16.919c.778-.123,1.42.607,1.751,1.743s1.012,4.453,1.21,5.332a22.391,22.391,0,0,0,2.931,7.475A2.894,2.894,0,0,1,26.6,32.576,25.143,25.143,0,0,1,23.284,27.1,30.213,30.213,0,0,1,21.6,20.662c-.363-2.151-.518-3.522.88-3.743",
    transform: "translate(-3.287 -9.673)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    d: "M4.2,91.359a6.62,6.62,0,0,1-.148.8A3.4,3.4,0,0,0,3.938,93.4c.064.292.891.706,1.35.767a2.869,2.869,0,0,1,1.428.886,2.629,2.629,0,0,0,2.006.756c.64-.074,1.362-.226,1.516-.486s-.06-.552-1.4-1.515-2.243-1.546-2.665-2.439Z",
    transform: "translate(22.785 -50.047)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    d: "M22.9,105.435a2.128,2.128,0,0,0,1.5.8,5.9,5.9,0,0,0,.93.037c.328,0,.831-.2.8-.609a.689.689,0,0,0-.172-.346c-.526-.684-1.091-1.34-1.573-2.059a6.54,6.54,0,0,1-1.276-2.79l-2.015.023c-.008.17-.054.409-.084.633s-.091.447-.141.67a1.834,1.834,0,0,0,.057,1.315,2.8,2.8,0,0,0,.775.709,7.454,7.454,0,0,1,1.2,1.615",
    transform: "translate(-0.779 -54.988)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-23",
    d: "M9.26,50.588c-.73,4.586,1.3,6.3,3.93,7.274,1.89.7,4.6,1.779,4.6,1.779s-.037,1.008-.058,3.267c-.019,1.99.242,9.253.242,9.253a2.19,2.19,0,0,0,2.015-.023s1.062-5.564,1.288-8.074c.305-3.4.824-5.631.651-6.363-.152-.645-3.85-2.474-5.025-3.454l7.749,2.611a13.9,13.9,0,0,0-.224,2.563c.071,2.7.219,8.546.219,8.546a1.67,1.67,0,0,0,1.969.015s1.95-11.572,1.714-13.1c-.224-1.454-7.053-4.425-8.256-5.448-.686-.584-1.452-1.207-1.452-1.207Z",
    transform: "translate(2.339 -26.656)",
    fill: "#12151c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    d: "M17.187,58.806a4.666,4.666,0,0,0,1.744-2.178,3.4,3.4,0,0,1-.419,1.81c-.054.327,6.425,2.979,6.425,2.979Z",
    transform: "translate(2.056 -31.213)",
    fill: "#aacaf9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-27",
    d: "M35.729,15.085s.112,2.185.063,2.378-1,.834-1.273,1.064,1.5,1.993,2.366,2.392,3.6-.653,3.652-2.006-.468-2.489-.889-2.549-3.92-1.279-3.92-1.279",
    transform: "translate(-21.468 -8.686)",
    fill: "#ffa8a7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-29",
    d: "M40.53,17.585c.286-.26-.044-.833-.241-1.232-.9-.272-3.328-1.268-3.328-1.268s.024.5.039.854a1.446,1.446,0,0,0,.581,1.077,3.947,3.947,0,0,0,.968.568c.357.139,1.32.6,1.98,0",
    transform: "translate(-22.701 -8.686)",
    fill: "#f28f8f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-31",
    d: "M32.248,18.712s.933,1.543,3.927,1.829a3.374,3.374,0,0,0-.355-3.161s.882-.715,1.486-.576a3.125,3.125,0,0,1,1.357,1.742,14.344,14.344,0,0,1,.776,5.057c-.037,2.318.073,8.073.073,8.073s.377,1.7-2.413,2.982a7.6,7.6,0,0,1-4.828.723c-1.114-.261-2.3-.687-2.544-1.214a43.48,43.48,0,0,0,.635-7.038c-.164-2.054-.6-3.551-.708-5.2s.216-1.618,1.039-2.207a12.951,12.951,0,0,1,1.555-1.008",
    transform: "translate(-18.233 -9.608)",
    fill: "#f5fbfb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-33",
    d: "M29.1,17.279a7.752,7.752,0,0,1,.878,7.388s.4,8.428.468,10.428a3.922,3.922,0,0,0,1.646-1.138,2.855,2.855,0,0,0,.962-2.408s-.156-3.074-.245-5.779.079-4.981-.578-6.9S30.434,16.6,30.434,16.6Z",
    transform: "translate(-11.511 -9.507)",
    fill: "#14e2c5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-35",
    d: "M32.468,17.846V16.9A4.978,4.978,0,0,1,33.71,18.45a19.677,19.677,0,0,1,.919,3.227c.087.56-.78,1.777-.78,1.777s.594.59.493.985a17.971,17.971,0,0,0-1.093,3.239c0-.119-.147-2.844-.147-2.844a14.214,14.214,0,0,0,.365-3.657,6.437,6.437,0,0,0-1-3.33",
    transform: "translate(-14.637 -9.673)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-37",
    d: "M38.067,20.28c.006.7,1.043,2.571,4.14,6.383.222,3.837.468,10.427.468,10.427S37.3,39.97,34.8,37.362c0,0,.165-1.222.595-3.315a25.746,25.746,0,0,0,.033-7.3c-.264-2.167-.891-4.06-.033-4.791a18.746,18.746,0,0,1,2.677-1.673",
    transform: "translate(-23.743 -11.503)",
    fill: "#14e2c5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-39",
    d: "M40.329,4.548h0a3.109,3.109,0,0,0-3.213-2.883,3.367,3.367,0,0,0-1.7,6.14,3.44,3.44,0,0,0,.269.741,4.815,4.815,0,0,0,3.009,1.093A1.593,1.593,0,0,0,40.076,8.5a7.659,7.659,0,0,0,.253-3.95",
    transform: "translate(-21.153 -1.406)",
    fill: "#ffa8a7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-41",
    d: "M40.943,3.181a3.305,3.305,0,0,0-3.474-1.448A3.369,3.369,0,0,0,36.28,7.8c-.037-.115-.913-1.433-.011-1.725a1.108,1.108,0,0,1,.188.692S36.9,6.73,36.8,6.2c-.028-.147-.054-.282-.078-.4a1.56,1.56,0,0,1,.257-1.17,1.366,1.366,0,0,0,.237-1.1,4.465,4.465,0,0,0,2.544.2,2.307,2.307,0,0,0,1.178-.545",
    transform: "translate(-22.019 -1.406)",
    fill: "#3a2c6d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(12.711 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-43",
    d: "M2.6,2.539a3.733,3.733,0,0,0,1.968.65A3.212,3.212,0,0,0,7.5,1.952c.444-.867-.442-.242-1.246-.674S2.447-.6,1.175,1.627c0,0-.726.116-.916.548A4.984,4.984,0,0,0,.423,5.117Z",
    transform: "translate(-0.11 -0.417)",
    fill: "#3a2c6d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-46",
    d: "M46.4,12.7s-.077.18-.4.2c-.61.03-1.324-1.109-.832-1.883a.793.793,0,0,1,1.226-.025Z",
    transform: "translate(-32.141 -6.311)",
    fill: "#ffa8a7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-48",
    d: "M49.195,41.972a11.482,11.482,0,0,0-1.169-.815,2.57,2.57,0,0,1-1-.732,11.079,11.079,0,0,1-1.192-3.339,14.5,14.5,0,0,1-.115-4.9c.359-1.946,1.3-4.631,1.57-5.744a1.807,1.807,0,0,0-.537-2.056c-.571-.542-1.436-.4-2.023,1.145a30.832,30.832,0,0,0-1.58,6.615,15.448,15.448,0,0,0,.341,5.018,17.984,17.984,0,0,0,1.545,4.052c.185.384.226.714.491,1.488A5.061,5.061,0,0,0,46.8,44.744c.517.445.773.525.908.458.17-.082.152-.261-.06-.492a4.16,4.16,0,0,1-.887-1.191s.44.528.732.82a4.113,4.113,0,0,0,.869.668c.31.17.78-.065.571-.3s-.435-.364-.86-.8a4.084,4.084,0,0,1-.591-.768,7.627,7.627,0,0,0,.964.752,1.7,1.7,0,0,0,.907.332c.172.008.4-.212.1-.472a6.194,6.194,0,0,1-1.147-.94c-.321-.381-.495-.7-.4-.695s.273.24.673.406c.383.16.853.087.925-.137s.054-.183-.314-.408",
    transform: "translate(-34.457 -13.571)",
    fill: "#ffa8a7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-50",
    d: "M51.174,56.83l.393.9s-.1.43-.9.8-1.073.228-1.073.228l-.453-1.012Z",
    transform: "translate(-39.199 -31.323)",
    fill: "#f5fbfb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-52",
    d: "M40.938,25.714s-2.095-3-2.859-4.012a10.187,10.187,0,0,1-1.261-2.628L36.8,18.53a.491.491,0,0,0-.463.266,15.106,15.106,0,0,1-.841,1.267,12.1,12.1,0,0,0,1.392,3.459,3.957,3.957,0,0,0,1.786,1.087s-.309,1.132.044,1.376a10.541,10.541,0,0,1,2.366,2.574Z",
    transform: "translate(-22.474 -10.553)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-54",
    d: "M51.38,23.965c.545.3,1.12.988.723,2.605s-1.075,3.64-1.4,5.1a11.882,11.882,0,0,0-.064,4.686c.3,1.4.778,2.9.778,2.9a3.675,3.675,0,0,1-2.151.988,16.819,16.819,0,0,1-1.406-4.923,21.849,21.849,0,0,1,1.392-9.559c1.042-2.566,2.125-1.8,2.125-1.8",
    transform: "translate(-39.243 -13.442)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-56",
    d: "M24.862,53.935l-5.207-3.024a.3.3,0,0,0-.3,0l-9.133,5.3,5.356,3.111Z",
    transform: "translate(5.318 -28.091)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-58",
    d: "M15.446,60.793l-2.809-1.63,8.212-4.768,2.823,1.621Z",
    transform: "translate(5.402 -30.002)",
    fill: "#aad1fc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-60",
    d: "M25.045,56.752l.052.03,1.377.8,2.448-1.421.051-.029L27.544,55.3Z",
    transform: "translate(-5.577 -30.494)",
    fill: "#aeb5b7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-62",
    d: "M25.157,56.852l1.377.8,2.448-1.421-1.378-.8Z",
    transform: "translate(-5.637 -30.564)",
    fill: "#aad1fc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-64",
    d: "M10.223,59.845v.123a.506.506,0,0,0,.251.438l4.854,2.819a.505.505,0,0,0,.5,0l8.782-5.1a.506.506,0,0,0,.251-.438v-.123l-9.284,5.391Z",
    transform: "translate(5.318 -31.721)",
    fill: "#454c5c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-66",
    d: "M10.223,62.955v.336a.494.494,0,0,0,.25-.067l8.782-5.1a.506.506,0,0,0,.251-.438v-.123Z",
    transform: "translate(10.674 -31.721)",
    fill: "#aad1fc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-68",
    d: "M7.235,55.526a.589.589,0,0,0,.513-.04l8.743-5.077a.6.6,0,0,0,.29-.418l.957-5.741a.644.644,0,0,0,.008-.1.6.6,0,0,0-.176-.426L8.483,49a.445.445,0,0,0-.213.31Z",
    transform: "translate(13.803 -24.217)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-70",
    d: "M7.618,55.343l.059.034a.579.579,0,0,0,.082.04L8.794,49.2a.443.443,0,0,1,.214-.309l9.086-5.278a.615.615,0,0,0-.121-.092L8.868,48.811a.443.443,0,0,0-.213.31Z",
    transform: "translate(13.278 -24.108)",
    fill: "#454c5c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-72",
    d: "M16.084,56.422a1.939,1.939,0,0,1,.882-1.14c.422-.246.713-.133.649.251a1.937,1.937,0,0,1-.881,1.14c-.422.245-.713.133-.649-.251",
    transform: "translate(9.878 -30.413)",
    fill: "#aad1fc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_4",
    "data-name": 4,
    transform: "translate(353.189 147.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39396_00000082369063725820569850000014136147221644146613_",
    transform: "translate(4.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79773_00000147918923915039504010000013583581780589998976_",
    d: "M2.319,1.892,1.908.616,1.565,2.042l-.124.066-1.024-.7.408,1.27-.26.137L0,1.066.223.949l1.187.815L1.793.12,2.015,0l.564,1.752Z",
    transform: "translate(0 5.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79774_00000182505562563589514870000005018021897153039007_",
    d: "M1.379.421l.2.625-.245.13-.044-.136a.507.507,0,0,1-.058.1.725.725,0,0,1-.09.1,1.04,1.04,0,0,1-.121.1,1.455,1.455,0,0,1-.153.092,1.183,1.183,0,0,1-.226.094.591.591,0,0,1-.187.026.266.266,0,0,1-.137-.04.191.191,0,0,1-.077-.1.266.266,0,0,1-.008-.133A.381.381,0,0,1,.3,1.13.792.792,0,0,1,.457.971,1.724,1.724,0,0,1,.719.8L1.13.588,1.118.55A.2.2,0,0,0,1.06.457a.174.174,0,0,0-.1-.041A.358.358,0,0,0,.828.431.885.885,0,0,0,.654.5a1.263,1.263,0,0,0-.12.071A1.281,1.281,0,0,0,.423.658a1.236,1.236,0,0,0-.1.094,1.134,1.134,0,0,0-.087.1L.083.771A1.527,1.527,0,0,1,.2.64,1.647,1.647,0,0,1,.331.521,1.69,1.69,0,0,1,.477.415,1.649,1.649,0,0,1,.632.325,1.394,1.394,0,0,1,.9.213.572.572,0,0,1,1.119.19.286.286,0,0,1,1.28.258a.356.356,0,0,1,.1.163M1.218.867,1.172.723l-.4.211a1.111,1.111,0,0,0-.156.1.452.452,0,0,0-.09.088A.2.2,0,0,0,.49,1.2a.141.141,0,0,0,0,.07.1.1,0,0,0,.044.058.149.149,0,0,0,.079.02.37.37,0,0,0,.11-.019.815.815,0,0,0,.136-.058A.98.98,0,0,0,1,1.184a.745.745,0,0,0,.106-.1A.535.535,0,0,0,1.179.98.388.388,0,0,0,1.218.867",
    transform: "translate(2.438 4.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79775_00000040575768685372459710000013902422709726699690_",
    d: "M1.5.449l.188.593-.259.137L1.247.607A.286.286,0,0,0,1.179.488a.2.2,0,0,0-.1-.055A.329.329,0,0,0,.935.441a.759.759,0,0,0-.17.068A.959.959,0,0,0,.586.63.6.6,0,0,0,.464.771.405.405,0,0,0,.407.926a.371.371,0,0,0,.015.165l.169.531-.259.137L0,.727.251.6.3.752A.64.64,0,0,1,.371.633a.884.884,0,0,1,.1-.115A1.168,1.168,0,0,1,.606.411a1.453,1.453,0,0,1,.158-.1,1.144,1.144,0,0,1,.249-.1A.553.553,0,0,1,1.226.2a.312.312,0,0,1,.167.075A.384.384,0,0,1,1.5.449",
    transform: "translate(4.029 3.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79776_00000013188764374670843390000014176691026332612511_",
    d: "M1.374.419l.2.624-.245.129-.043-.136a.507.507,0,0,1-.058.1.724.724,0,0,1-.09.1,1.037,1.037,0,0,1-.121.1,1.449,1.449,0,0,1-.152.092,1.176,1.176,0,0,1-.226.093.587.587,0,0,1-.186.025.264.264,0,0,1-.136-.04.191.191,0,0,1-.076-.1.267.267,0,0,1-.007-.133A.382.382,0,0,1,.3,1.126.791.791,0,0,1,.455.968,1.717,1.717,0,0,1,.716.8L1.125.585,1.113.548A.2.2,0,0,0,1.056.455.173.173,0,0,0,.96.414.356.356,0,0,0,.825.429.88.88,0,0,0,.652.5a1.258,1.258,0,0,0-.12.071A1.277,1.277,0,0,0,.421.655a1.234,1.234,0,0,0-.1.094,1.136,1.136,0,0,0-.087.1L.082.767A1.525,1.525,0,0,1,.2.637,1.644,1.644,0,0,1,.33.517,1.684,1.684,0,0,1,.475.412,1.641,1.641,0,0,1,.63.323,1.387,1.387,0,0,1,.9.211.569.569,0,0,1,1.115.188a.284.284,0,0,1,.16.068.355.355,0,0,1,.1.163M1.213.864,1.168.72l-.4.211a1.107,1.107,0,0,0-.155.1.451.451,0,0,0-.09.088.2.2,0,0,0-.037.079.141.141,0,0,0,0,.07.1.1,0,0,0,.044.058.148.148,0,0,0,.079.02.368.368,0,0,0,.11-.019.81.81,0,0,0,.136-.058.974.974,0,0,0,.133-.084.744.744,0,0,0,.106-.1A.536.536,0,0,0,1.174.977a.389.389,0,0,0,.04-.113",
    transform: "translate(5.621 3.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79777_00000109740308610099488230000015194550962610040243_",
    d: "M1.5.013,1.86,1.162a.958.958,0,0,1,.048.329.7.7,0,0,1-.074.287.853.853,0,0,1-.192.247,1.481,1.481,0,0,1-.306.209,1.793,1.793,0,0,1-.2.09,1.465,1.465,0,0,1-.2.06,1.007,1.007,0,0,1-.185.026A.6.6,0,0,1,.594,2.4L.66,2.144a.8.8,0,0,0,.147.01.9.9,0,0,0,.152-.017A1.01,1.01,0,0,0,1.112,2.1a1.116,1.116,0,0,0,.15-.068,1.009,1.009,0,0,0,.209-.143A.549.549,0,0,0,1.6,1.721a.45.45,0,0,0,.046-.186.642.642,0,0,0-.033-.212l-.033-.105a.917.917,0,0,1-.079.148.959.959,0,0,1-.228.243.9.9,0,0,1-.141.086.985.985,0,0,1-.3.1.643.643,0,0,1-.271-.01.486.486,0,0,1-.216-.123A.558.558,0,0,1,.2,1.433a.7.7,0,0,1-.028-.292A.815.815,0,0,1,.264.858,1,1,0,0,1,.452.606a1.164,1.164,0,0,1,.272-.2A.83.83,0,0,1,.877.339.723.723,0,0,1,1.031.306a.618.618,0,0,1,.15,0A.535.535,0,0,1,1.32.348L1.255.142ZM1.445.776A.379.379,0,0,0,1.353.619.319.319,0,0,0,1.209.536.428.428,0,0,0,1.027.53.69.69,0,0,0,.82.6.817.817,0,0,0,.632.739.67.67,0,0,0,.5.909a.538.538,0,0,0-.059.19.475.475,0,0,0,.019.2.378.378,0,0,0,.092.156A.324.324,0,0,0,.7,1.534a.431.431,0,0,0,.184.007.685.685,0,0,0,.208-.073.8.8,0,0,0,.186-.136.672.672,0,0,0,.127-.171A.548.548,0,0,0,1.464.971.476.476,0,0,0,1.445.776",
    transform: "translate(6.993 1.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79778_00000113323712686485272670000001176223944245941417_",
    d: "M1.6.591.443,1.2a.236.236,0,0,0,.093.1.316.316,0,0,0,.14.037.569.569,0,0,0,.176-.021.978.978,0,0,0,.2-.081.926.926,0,0,0,.113-.067.94.94,0,0,0,.1-.081A.879.879,0,0,0,1.354.99a.758.758,0,0,0,.069-.1L1.6.935a.843.843,0,0,1-.086.13,1.073,1.073,0,0,1-.115.122,1.343,1.343,0,0,1-.141.112,1.631,1.631,0,0,1-.166.1,1.378,1.378,0,0,1-.325.126A.755.755,0,0,1,.5,1.543a.419.419,0,0,1-.208-.085.374.374,0,0,1-.122-.184.5.5,0,0,1-.013-.24A.723.723,0,0,1,.25.789,1.051,1.051,0,0,1,.442.56,1.328,1.328,0,0,1,.714.37a1.154,1.154,0,0,1,.3-.111A.666.666,0,0,1,1.266.251a.408.408,0,0,1,.2.091.407.407,0,0,1,.12.19l0,.013,0,.015,0,.016,0,.015M.4,1.066,1.313.584a.226.226,0,0,0-.1-.1A.332.332,0,0,0,1.073.45.54.54,0,0,0,.9.473.746.746,0,0,0,.713.557a.806.806,0,0,0-.14.111.7.7,0,0,0-.1.13.511.511,0,0,0-.06.137A.329.329,0,0,0,.4,1.066",
    transform: "translate(8.804 1.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79779_00000142135239812502407770000011953114073591596190_",
    d: "M1.972,1.914l-.787-.426L.856,2.5l-.308.163L.972,1.4.042.893.348.731l.736.4.31-.948L1.686.025l-.4,1.2.991.53Z",
    transform: "translate(10.001)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_39389",
    "data-name": "Group 39389",
    transform: "translate(0 6.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78967_00000156546114711580636900000015945959367159725749_",
    d: "M1.269.68A.116.116,0,0,1,1.284.644.127.127,0,0,1,1.31.615.118.118,0,0,1,1.343.6.1.1,0,0,1,1.38.589H1.39l.01,0L1.41.6,1.418.6,1.9.928,2,.547,1.64.306A.324.324,0,0,0,1.5.254a.415.415,0,0,0-.16.013A.523.523,0,0,0,1.18.342a.584.584,0,0,0-.135.13q-.017.023-.032.047a.559.559,0,0,0-.027.05A.535.535,0,0,0,.964.619.5.5,0,0,0,.949.671L.533,2.383a.43.43,0,0,0-.009.168.335.335,0,0,0,.054.139.3.3,0,0,0,.107.1.339.339,0,0,0,.151.038.408.408,0,0,0,.057,0,.447.447,0,0,0,.057-.01.486.486,0,0,0,.057-.018.522.522,0,0,0,.056-.026l.83-.439a.177.177,0,0,0,.033-.023.185.185,0,0,0,.027-.029.179.179,0,0,0,.02-.034.161.161,0,0,0,.012-.037h0a.356.356,0,0,1-.074-.014.321.321,0,0,1-.066-.029.3.3,0,0,1-.1-.1l-.775.41a.1.1,0,0,1-.036.012.081.081,0,0,1-.033,0A.066.066,0,0,1,.853,2.44a.079.079,0,0,1,0-.011.087.087,0,0,1,0-.012.094.094,0,0,1,0-.012.1.1,0,0,1,0-.013Z",
    transform: "translate(0 0.959)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78968_00000095334925852689673160000009188223499938641562_",
    d: "M3.1,1.485,1.865.65A.312.312,0,0,0,1.771.607.363.363,0,0,0,1.665.594a.437.437,0,0,0-.112.019.512.512,0,0,0-.112.049.588.588,0,0,0-.094.07.608.608,0,0,0-.078.087.59.59,0,0,0-.059.1.537.537,0,0,0-.037.108l-.117.48-.093.381L.732,3.06l-.075.383L.95,3.288a.177.177,0,0,0,.033-.023.185.185,0,0,0,.027-.029A.179.179,0,0,0,1.03,3.2a.161.161,0,0,0,.012-.037h0l.2-1.093.748.588h0a.1.1,0,0,0,.03.016.117.117,0,0,0,.035.006.14.14,0,0,0,.037,0,.168.168,0,0,0,.038-.015l.816-.432a.573.573,0,0,0,.147-.112.583.583,0,0,0,.1-.148.5.5,0,0,0,.048-.164.39.39,0,0,0-.016-.162A.343.343,0,0,0,3.206,1.6a.317.317,0,0,0-.027-.044.3.3,0,0,0-.034-.038.3.3,0,0,0-.04-.032Zm-.193.375a.111.111,0,0,1-.008.025.122.122,0,0,1-.014.023.125.125,0,0,1-.018.019.12.12,0,0,1-.022.015l-.7.372-.262-.2-.265-.2-.205-.156-.082-.063.163-.669A.116.116,0,0,1,1.509.987.127.127,0,0,1,1.535.958.118.118,0,0,1,1.568.939.1.1,0,0,1,1.6.932h.011l.01,0,.009,0,.009.005,1.24.835a.065.065,0,0,1,.016.015.068.068,0,0,1,.01.019.079.079,0,0,1,0,.022A.1.1,0,0,1,2.911,1.859Z",
    transform: "translate(0.943 -0.001)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniquelyAddressing);
export default __webpack_public_path__ + "static/media/Uniquely Addressing.436a72eb0fef2253512adf39bda37b77.svg";
export { ForwardRef as ReactComponent };